export type Language = "en" | "hi" | "pa"

export const languages: { code: Language; label: string }[] = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
]

// UI copy dictionary
export const uiText: Record<Language, Record<string, string>> = {
  en: {
    title: "My Digital Panchayat : My Proud",
    welcome_title: "Welcome to Haryana's Digital Village Network",
    welcome_body:
      "Explore all 6,222 Gram Panchayats across Haryana. Get access to information, schemes, development updates, and connect with your Panchayat online.",
    select_district: "Select District",
    select_block_first: "Select District first",
    select_block: "Select Block",
    select_village_first: "Select Block first",
    select_village: "Select Village Panchayat",
    select_level: "Select Institution Type",
    search_gp_label: "Search gram panchayat",
    search_gp_placeholder: "Search gram panchayat",
    clear_search: "Clear search",
    search_gp_no_matches: "No matches",
    loading: "Loading...",
    loading_districts: "Loading districts...",
    no_districts_available: "No districts available",
    no_blocks_available: "No blocks available",
    no_gram_panchayats_available: "No Gram Panchayats available",
    selected_panchayats: "Selected",
    reselect_panchayat: "Reselect gram panchayat",
    remove_selection: "Remove selection",
    admin_data_load_failed: "Failed to load administrative data",
    retry: "Retry",
    go: "Go",
    continue: "Continue",
    level_zp: "Zila Parishad",
    level_bs: "Block Samiti",
    level_gp: "Gram Panchayat",
    level_zp_short_line1: "Zila",
    level_zp_short_line2: "Parishad",
    level_bs_short_line1: "Block",
    level_bs_short_line2: "Samiti",
    level_gp_short_line1: "Gram",
    level_gp_short_line2: "Panchayat",
    first_select_institution: "First select your institution",
    sign_in_required_title: "Sign in required",
    sign_in_required_message: "Please sign in to continue.",
    sign_in_with_google: "Sign In",
    news_title: "Latest",
    news_tabs_announcements: "News/Announcements",
    ad_title: "Advertisement Space",
    ad_body:
      "Promote your business, service, or local product here. Contact",
    dashboard_title: "Haryana State Dashboard",
    total_panchayats: "Total Panchayats",
    districts: "Districts",
    registered_users: "Registered Users",
    footer: "© 2025 My Panchayat : My Proud. Developed by Tech Maestro Digital Services.",
    caption_pm: "Sh. Narendra Modi, Prime Minister, Government of India",
    caption_cm: "Sh. Nayab Singh Saini, Chief Minister, Government of Haryana",
    caption_minister: "Sh. Krishan Lal Panwar, Minister of Development and Panchayati Raj, Government of Haryana",
    cm_name: "Sh. Nayab Singh Saini",
    cm_designation: "Chief Minister, Government of Haryana",
    pm_name: "Sh. Krishan Lal Panwar",
    pm_designation: "Minister of Development and Panchayati Raj",
    panch_ward_label: "Panch Ward No.",
    block_samitis: "Block Samitis",
    data_source_label: "Source",
    data_source_value: "Official Haryana Panchayati Raj administrative records (2025)",
    level_header_tagline: "Let's meet and tour your village panchayat",
    sarpanch_of_village: "Sarpanch of {village}",
    sarpanch_placeholder_aria: "Sarpanch placeholder",
    sarpanch_title: "Sarpanch",
    panch_ward_prefix: "Panch Ward",
    block_samiti_member_label: "Block Samiti Member",
    zila_parishad_member_label: "Zila Parishad Member",
    consensus_label: "* Elected by Consensus",
    correction_link_text: "#Click here to update the correction in name",
    correction_name_update_template: "webpage of gram panchayat {gp}/block {block}/district {district} needs name updation as suggested..",
    show_images: "Show Images",
    hide_images: "Hide Images",
    correction_message: "This web page fetches details from three dropdown lists and needs correction. Please explain where to make the changes.",
    data_unavailable: "Data Unavailable",
    ward_data_unavailable_btn: "Data Not Available",
    ward_whatsapp_template: "I am panch of ward no.{ward} from gram panchayat {gp}, block {block}, district {district}. Please update in the website, my name and father/husband name.",
    prev_body_label: "Previous {level}",
    curr_body_label: "Current {level}",
    previous_gram_panchayat: "Previous Gram Panchayat",
    previous_block_samiti: "Previous Block Samiti",
    previous_zila_parishad: "Previous Zila Parishad",
    whatsapp_image_request_template: "I, {name}, {designation}, gram panchayat {gp}, block {block}, district {district}, am interested to display my photo on this website. Give me more information for this. Thanks.",
    whatsapp_former_prefix: "Former ",
    whatsapp_name_missing: "Name unavailable",
    whatsapp_location_missing: "Unavailable",
    click_to_display_image: "Click here to display your image",
    image_prompt_l1: "Click here",
    image_prompt_l2: "to display",
    image_prompt_l3: "your image",
    // Chairperson caption lines and labels
    chairperson_title: "Chairperson",
    vice_chairperson_title: "Vice-Chairperson",
    chairperson_zp_line: "Chairperson, Zila Parishad, {parishad}",
    chairperson_bs_line: "Chairperson, Block Samiti, {samiti}",
    vice_chairperson_zp_line: "Vice-Chairperson, Zila Parishad, {parishad}",
    vice_chairperson_bs_line: "Vice-Chairperson, Block Samiti, {samiti}",
    unknown_label: "unknown",
    // Welcome message variants for Gram Panchayat subpage
    dropdown_welcome_msg: "Welcome to Gram Panchayat {village}",
    welcome_to_gp: "Welcome to Gram Panchayat",
    welcome_gp_main: "Welcome to Gram Panchayat {village}",
    welcome_loc_suffix: "({district})",
    welcome_gp_heading: "Welcome to Gram Panchayat {village}",
    welcome_dynamic_loc: "Welcome to {village} , {block} , {district}",
    welcome_bs_heading: "Welcome to Block Samiti {block}",
    welcome_zp_heading: "Welcome to Zila Parishad {district}",
    institution_gp_heading: "Gram Panchayat {village}",
    institution_bs_heading: "Block Samiti {block}",
    institution_zp_heading: "Zila Parishad {district}",
    gp_location_line: "{district} · {block}",
    latest_updates_title: "Latest Updates",
    // Farmer ID (AgriStack) Translations
    agristack_benefits_title: "Farmer ID (AgriStack) — Benefits",
    agristack_benefit_1: "Unique digital Farmer ID for Haryana farmers.",
    agristack_benefit_2: "Links Aadhaar, land records, and bank account.",
    agristack_benefit_3: "Required to access PM-KISAN, PMFBY, subsidies, and future schemes.",
    agristack_benefit_4: "Ensures faster and transparent benefit delivery.",
    agristack_eligibility_title: "Eligibility",
    agristack_eligibility_1: "Haryana domicile farmer.",
    agristack_eligibility_2: "Aadhaar linked with mobile number.",
    agristack_eligibility_3: "Land records registered in Haryana revenue system.",
    agristack_eligibility_4: "Individual or joint landholders eligible.",
    agristack_documents_title: "Required Documents",
    agristack_doc_1: "Aadhaar card (OTP-enabled).",
    agristack_doc_2: "Haryana land record (Jamabandi / Bhulekh).",
    agristack_doc_3: "Bank passbook (Aadhaar-linked).",
    agristack_doc_4: "Passport-size photograph.",
    already_applied: "Already Applied",
    apply_now: "Apply Now",
    upload_documents_title: "Upload Documents to My Document Wallet",
    upload_documents_instruction: "Please upload your Farmer ID related documents for secure storage in your profile.",
    farmer_id_label: "Farmer ID (if generated)",
    aadhaar_label: "Aadhaar",
    land_record_label: "Land record",
    bank_passbook_label: "Bank passbook",
    save_to_wallet: "Save to My Document Wallet",
    private_docs_note: "These documents remain private and accessible only to you.",
    how_to_apply_title: "How to Apply (Haryana)",
    how_to_apply_step_1: "Visit the official Haryana Farmer Registry portal.",
    how_to_apply_step_2: "Verify Aadhaar using OTP.",
    how_to_apply_step_3: "Fill personal, land, and bank details.",
    how_to_apply_step_4: "Submit application to generate Farmer ID.",
    prepare_documents_title: "Prepare Before Applying",
    prepare_doc_1: "Keep Aadhaar & mobile phone ready.",
    prepare_doc_2: "Verify Jamabandi details.",
    prepare_doc_3: "Ensure bank account is Aadhaar-linked.",
    prepare_doc_4: "Scan documents clearly.",
    official_portal_link_title: "Proceed to Official Haryana Portal",
    official_portal_message: "All steps, verification, and any applicable payments will be completed only on the official government website. After successful registration, please return and upload your documents to ‘My Document Wallet’.",
    go_to_official_portal: "Go to Official Haryana Farmer ID Portal",
    haryana_agri_dept: "Haryana Government – Department of Agriculture & Farmers Welfare",
    gp_not_found: "Gram Panchayat not found",
    block_not_found: "Block not found",
    district_shard_not_found: "District data not found",
    failed_to_load_gp_data: "Failed to load Gram Panchayat data",
    error: "Error",
    dismiss: "Dismiss",
    back: "Back",
    subtitle_farmer: "Access schemes, subsidies, land records, and rural services",
    subtitle_academics: "Find admissions, exams, results, and job opportunities easily.",
    subtitle_certificates: "Apply for important certificates and civic services without confusion.",
    subtitle_grievances: "Register complaints, track requests, and get support",
    subtitle_travel: "Book travel, check routes, and access transport-related services.",
    // Quick Links Tabs
    tab_weather_gp: "Village Weather",
    tab_weather_bs: "Block Weather",
    tab_weather_zp: "District Weather",
    tab_services: "Online Services",
    tab_eminent_gp: "Eminent Persons",
    tab_eminent_bs: "Block Eminent Persons",
    tab_eminent_zp: "District Eminent Persons",
    honour_board_gp: "Village Digital Honour Board",
    honour_board_bs: "Block Digital Honour Board",
    honour_board_zp: "District Digital Honour Board",
    apply_online: "Apply Online",
    rules_regulations: "Rules & Regulations",
    tab_community_gp: "Samvaad",
    tab_community_bs: "Block Community",
    tab_community_zp: "District Community",
    tab_reels: "Reelgram",
    tab_music: "My Music",
    tab_village_hub: "Village Hub",
    tab_tour_gp: "Village Tour",
    tab_tour_bs: "Block Tour",
    tab_tour_zp: "District Tour",
    tab_voter: "Voter & Election",
    footer_services_title: "Services",
    footer_policies_title: "Our Policies",
    footer_connect_title: "Connect With Us",
    footer_tagline: "Empowering villages through digital governance",
    footer_total_visitors: "Total Visitors",
    footer_total_views: "Total Views",
    footer_institution_views: "This Institution Views",
    footer_policy_privacy: "Privacy Policy",
    footer_policy_terms: "Terms of Use",
    footer_policy_cookie: "Cookie Policy",
    footer_policy_gdpr: "GDPR Policy",
    footer_policy_refund: "Refund Policy",
    footer_policy_accessibility: "Accessibility Policy",
    footer_policy_data_usage: "Data Usage Policy",
    policy_effective_date: "Effective Date",
    policy_last_updated: "Last Updated",
    policy_back_home: "Back to Home",
    policy_not_found: "Policy not found",
    footer_whatsapp: "WhatsApp",
    footer_copyright: "© 2026 Digital Panchayat Mission | All Rights Reserved",
    footer_powered_by: "Powered by Tech Maestro Digital Services",
    footer_nav_home: "Home",
    footer_nav_weather: "Weather",
    footer_nav_online_services: "Online Services",
    footer_nav_village_hub: "Village Hub",
    footer_nav_village_tour: "Village Tour",
    footer_nav_samvaad: "Samvaad",
    footer_nav_my_music: "My Music",
    footer_nav_reelgram: "Reelgram",
    footer_nav_elections: "Elections",
    // Quick Links Tooltips
    tab_weather_gp_tooltip: "View detailed weather forecast for the village",
    tab_weather_bs_tooltip: "View detailed weather forecast for the block",
    tab_weather_zp_tooltip: "View detailed weather forecast for the district",
    tab_services_tooltip: "Access online government services",
    tab_eminent_gp_tooltip: "View eminent persons of the village",
    tab_eminent_bs_tooltip: "View eminent persons of the block",
    tab_eminent_zp_tooltip: "View eminent persons of the district",
    tab_community_gp_tooltip: "Connect with Samvaad",
    tab_community_bs_tooltip: "Connect with the block community",
    tab_community_zp_tooltip: "Connect with the district community",
    tab_reels_tooltip: "Watch local short videos",
    tab_music_tooltip: "Listen to local music",
    tab_village_hub_tooltip: "Explore the Village Hub and its key information",
    vf_village_hub: "Village Hub",
    vf_nav_hub: "Village Hub",
    vf_nav_notice: "Panchayat Notice",
    vf_nav_need: "Service Need",
    vf_notifications_soon: "Notifications coming soon",
    vf_create_post: "Create Post",
    vf_choose_category: "Choose category",
    vh_choose_category: "Choose post category",
    vh_choose_option: "Choose how to create",
    vh_option_upload: "Upload",
    vh_option_upload_desc: "Upload photos, videos, or documents from your device.",
    vh_option_fresh: "Create Fresh",
    vh_option_fresh_desc: "Write a caption, add hashtags, tag location, edit media, and schedule.",
    vh_option_live: "Live Stream",
    vh_option_live_desc: "Use your camera to record a live-style post with title and privacy.",
    vh_add_media: "Add media",
    vh_pick_files: "Pick files",
    vh_media_too_large: "One or more files are too large for upload.",
    vh_camera_denied: "Camera access denied or not available.",
    vh_live_not_supported: "Live recording is not supported on this device.",
    vh_location_tag: "Location tag (optional)",
    vh_location_placeholder: "Add a place name or landmark",
    vh_scheduling: "Schedule (optional)",
    vh_scheduling_note: "If scheduling is not supported by your backend schema, the post will publish immediately.",
    vh_media_edit: "Media editing",
    vh_crop: "Crop",
    vh_filter: "Filter",
    vh_filter_none: "None",
    vh_filter_warm: "Warm",
    vh_filter_mono: "Mono",
    vh_filter_vivid: "Vivid",
    vh_live_setup: "Live stream setup",
    vh_live_title: "Live title",
    vh_live_description: "Description",
    vh_privacy_public: "Public",
    vh_privacy_village: "Village",
    vh_privacy_private: "Private",
    vh_camera_start: "Start camera",
    vh_camera_stop: "Stop camera",
    vh_live_start: "Start recording",
    vh_live_stop: "Stop recording",
    vh_fmt_bold: "Bold",
    vh_fmt_italic: "Italic",
    vh_fmt_underline: "Underline",
    vh_err_permission: "You don’t have permission to post.",
    vh_err_network: "Network error. Please try again.",
    vh_err_sign_in: "Sign in required to post.",
    vh_err_unknown: "Could not post. Please try again.",
    vh_err_category_required: "Please select a category.",
    vh_err_bucket_missing: "Storage bucket village-feed-media does not exist.",
    vf_message: "Message",
    vf_whats_happening: "What’s happening in your village today?",
    vh_sticky_prompt: "what's happening in your village today ?",
    vh_post_now: "Post Now",
    vh_create_post: "create post",
    vh_language_toggle: "Language",
    vh_language_hi: "हिन्दी",
    vh_language_pa: "ਪੰਜਾਬੀ",
    vh_language_hi_short: "हि",
    vh_language_pa_short: "ਪੰ",
    vh_profile_missing_toast: "Complete your profile first (missing details detected).",
    vf_post: "Post",
    vf_posting: "Posting...",
    vf_uploading: "Uploading...",
    vf_posted: "Posted",
    vf_posted_success: "Posted successfully",
    vf_post_failed: "Could not post",
    vf_add_media: "Add photo, video or voice",
    vf_text: "Text",
    vf_photo: "Photo",
    vf_video: "Video",
    vf_audio: "Audio",
    vf_stop: "Stop",
    vf_remove_audio: "Remove voice",
    vf_optional: "Optional",
    vf_tags: "Tags",
    vf_add_tags: "Add tags (optional)",
    vf_buy_sell_details: "Buy/Sell details",
    vf_item_name: "Item name",
    vf_item_required: "Item name is required",
    vf_item: "Item",
    vf_price: "Price",
    vf_price_unknown: "Price not given",
    vf_negotiable: "Negotiable",
    vf_emergency: "Emergency",
    vf_emergency_details: "Emergency details",
    vf_urgency: "Urgency",
    vf_urgency_high: "High",
    vf_urgency_medium: "Medium",
    vf_urgency_low: "Low",
    vf_sell_item: "Sell Item",
    vf_need_help: "Need Help",
    vf_agri_update: "Agriculture",
    vf_login_prompt_title: "Join your village feed",
    vf_login_prompt_text: "Login to post, like and save updates.",
    vf_login_to_interact: "Login to interact",
    vf_filter_all: "All",
    vf_filter_agriculture: "Agriculture",
    vf_filter_buy_sell: "Buy/Sell",
    vf_filter_emergency: "Emergency",
    vf_filter_events: "Events",
    vf_filter_education: "Education",
    vf_filter_labour: "Labour",
    vf_load_failed: "Could not load feed",
    vf_load_failed_hint: "If this is the first time, the Village Feed tables may not be created yet.",
    vf_empty_title: "No posts yet",
    vf_empty_text: "Be the first to share an update in your village.",
    vf_first_post_title: "Be the first person to post in your Gram Panchayat.",
    vf_first_post_text: "Start a local update so your Panchayat stays connected.",
    vf_empty_cta_1: "Share first village update",
    vf_empty_cta_2: "Post agriculture update",
    vf_empty_cta_3: "Sell items locally",
    vf_end: "You’re all caught up",
    vf_scope_all: "All",
    vf_scope_gp: "My Panchayat",
    vf_scope_nearby: "Nearby",
    vf_scope_block: "Block",
    vf_scope_district: "District",
    vf_scope_state: "State",
    vf_follow: "Follow",
    vf_following: "Following",
    vh_filter_all: "All",
    vh_filter_my_panchayat: "My Panchayat",
    vh_filter_nearby: "Nearby",
    vh_filter_block: "Block",
    vh_filter_district: "District",
    vh_filter_state: "State",
    vh_filter_haryana: "Haryana",
    vh_nearby_loading: "Loading nearby Village Hub posts...",
    vh_nearby_permission_required: "Location permission is required to view nearby Village Hub posts.",
    vh_nearby_location_unavailable: "Unable to get your current location. Please try again.",
    vh_nearby_no_posts: "No nearby Village Hub posts found within 10 km.",
    vf_villager: "Villager",
    vf_now: "Now",
    vf_time_m: "m",
    vf_time_h: "h",
    vf_time_d: "d",
    vf_post_aria: "Village post",
    vf_action_failed: "Action failed",
    vf_share: "Share",
    vf_share_whatsapp: "WhatsApp",
    vf_share_facebook: "Facebook",
    vf_share_native: "Share",
    vf_share_instagram: "Instagram",
    vf_comments: "Comments",
    vf_share_title: "Village Feed",
    vf_native_share: "Share",
    vf_copy_link: "Copy link",
    vf_post_image: "Post image",
    vf_open_document: "Open document",
    vf_verified: "Verified",
    vf_post_time: "Post time",
    vf_categories_loading: "Loading categories...",
    vf_categories_load_failed: "Failed to load categories",
    vf_categories_load_empty: "Failed to load categories (0 rows). This is usually caused by access policies.",
    vf_audio_not_supported: "Voice recording not available on this device.",
    vf_section_your_gp: "Your Gram Panchayat",
    vf_section_selected_gp: "Selected Gram Panchayat",
    vf_section_nearby_gp: "Nearby Gram Panchayats",
    vf_section_your_block: "Your Block",
    vf_section_your_district: "Your District",
    vf_section_across_haryana: "Across Haryana",
    vf_coming_soon: "This section is coming soon.",
    vf_category_general: "General",
    vf_category_buy_sell: "Buy/Sell",
    vf_category_agriculture: "Agriculture",
    vf_category_emergency: "Emergency",
    vf_category_event: "Event",
    vf_category_events: "Events",
    vf_category_labour: "Labour",
    vf_category_missing: "Missing",
    vf_category_medical: "Medical Help",
    vf_category_education: "Education",
    vf_category_transport: "Transport",
    vf_category_news: "News",
    vf_category_entertainment: "Entertainment",
    vf_category_sale_purchase: "Sale/Purchase",
    vf_category_advertisement: "Advertisement",
    vf_category_others: "Others",
    vh_profile_required_title: "Complete your profile to create a post",
    vh_profile_required_desc: "Please fill the required details below, then try creating your post again.",
    vh_missing_full_name: "Full name required",
    vh_missing_gp: "Gram Panchayat required",
    vh_missing_phone_verified: "Verified mobile required",
    vh_missing_unknown: "Missing details",
    vf_onboard_1_title: "Share village updates",
    vf_onboard_1_text: "Post daily updates, events and announcements for your village.",
    vf_onboard_2_title: "Buy & Sell locally",
    vf_onboard_2_text: "Sell items nearby and find what you need within the village.",
    vf_onboard_3_title: "Get help instantly",
    vf_onboard_3_text: "Post emergencies, medical help or urgent needs.",
    vf_onboard_4_title: "Connect with Panchayat",
    vf_onboard_4_text: "Stay informed with notices and important updates.",
    vf_skip: "Skip",
    vf_back: "Back",
    vf_next: "Next",
    vf_start: "Start",
    vf_comments_title: "Comments",
    vf_comment_placeholder: "Write a comment...",
    vf_send: "Send",
    vf_no_comments: "No comments yet. Be the first to comment.",
    vf_load_more_comments: "Load older comments",
    vf_comments_failed: "Could not load comments",
    vf_comment_failed: "Could not send comment",
    vf_login_to_comment: "Login to comment",
    tab_tour_gp_tooltip: "Take a virtual tour of the village",
    tab_tour_bs_tooltip: "Take a virtual tour of the block",
    tab_tour_zp_tooltip: "Take a virtual tour of the district",
    tab_voter_tooltip: "View voter and election information",
    voter_list_title: "Voter List",
    disclaimer_label: "Disclaimer",
    disclaimer_text: "PRI members' images are published with the consent for public information purposes only. This platform is not an official government record. Any member may request correction or removal of their information at any time.",
    voter_list_desc: "Download the latest voter list for your area.",
    download_pdf: "Download PDF",
    election_comm_title: "Election Commission",
    election_comm_desc: "Visit the official Election Commission portal.",
    visit_website: "Visit Website",
    important_info: "Important Information",
    election_dates_msg: "Dates for upcoming Panchayat elections will be announced soon. Please check regularly for updates.",
    reel_label: "Reel {index}",
    music_track_label: "Folk Song Track {index}",
    music_artist_label: "Local Artist",
    tour_site_label: "Historical Site {index}",
    tour_site_desc: "A beautiful location to visit.",
    // Weather
    village_weather: "Village Weather",
    weather_feels_like: "Feels Like",
    weather_now: "Now",
    weather_hourly_forecast: "Hourly Forecast",
    weather_7_day_forecast: "7-Day Forecast",
    weather_alert: "Weather Alert",
    weather_alert_rain_desc: "Rain is expected. Please ensure crops are protected if necessary.",
    weather_search_placeholder: "Search District or Block...",
    weather_recent: "Recent",
    weather_no_matches: "No matches found",
    weather_search_prompt: "Search for a location to see the weather.",
    weather_humidity: "Humidity",
    weather_wind: "Wind",
    weather_sunrise: "Sunrise",
    weather_sunset: "Sunset",
    weather_select_location: "Select a location",
    weather_unknown: "Unknown",
    weather_clear_sky: "Clear Sky",
    weather_partly_cloudy: "Partly Cloudy",
    weather_foggy: "Foggy",
    weather_rainy: "Rainy",
    weather_snow: "Snow",
    weather_showers: "Showers",
    weather_thunderstorm: "Thunderstorm",
    // Weather Advanced
    weather_precipitation: "Precipitation",
    weather_chance: "Chance",
    weather_wind_direction: "Wind Direction",
    weather_disease_risk: "Disease Risk",
    weather_wind_conditions: "Wind & Conditions",
    weather_alert_heatwave_warning: "Heatwave Warning",
    weather_alert_heatwave_warning_msg: "Stay hydrated, avoid noon sun",
    weather_alert_severe_heatwave: "Severe Heatwave",
    weather_alert_severe_heatwave_msg: "Extreme heat! Stay indoors, hydrate frequently.",
    weather_alert_coldwave_warning: "Coldwave Warning",
    weather_alert_coldwave_warning_msg: "Freezing temperatures. Protect crops and livestock.",
    weather_alert_rain_risk: "Moderate Rain Risk",
    weather_alert_rain_risk_msg: "Ensure field drainage",
    weather_alert_rain_advisory: "Light Rain Advisory",
    weather_alert_rain_advisory_msg: "Light showers possible. Monitor crop moisture.",
    weather_alert_storm_severe: "Severe Storm Alert",
    weather_alert_storm_severe_msg: "High winds and potential lightning. Seek shelter.",
    weather_alert_storm_advisory: "Wind Advisory",
    weather_alert_storm_advisory_msg: "Gusty winds expected. Secure loose structures.",
    weather_forecast_today: "Today",
    weather_forecast_tomorrow: "Tomorrow",
    weather_cond_sunny: "Sunny",
    weather_cond_cloudy: "Cloudy",
    weather_cond_broken_clouds: "Broken Clouds",
    weather_cond_overcast: "Overcast",
    weather_cond_rain: "Rain",
    weather_cond_storm: "Storm",
    weather_cond_clear_sky: "Clear sky",
    weather_cond_partly_cloudy: "Partly cloudy",
    weather_cond_light_rain: "Light rain",
    weather_cond_moderate_rain: "Moderate rain",
    weather_cond_thunderstorm: "Thunderstorm",
    weather_location_error: "Location coordinates not found for {block}, {district}. Using default.",
    weather_gis_file_error: "Location database file is missing or corrupted.",
    weather_gis_district_not_found: "District not found in location database: {district}.",
    weather_gis_filter_invalid: "Location database entry is invalid for district: {district}.",
    weather_gis_invalid_coords: "Invalid coordinates found for district: {district}.",
    weather_light_showers: "Light showers",
    weather_expected: "expected",
    weather_gis_error: "Location coordinates not found for {block}, {district}. Using default.",
    weather_gis_load_error: "Failed to load location database.",
    weather_fetch_error: "Unable to fetch weather data. Please try again later.",
    weather_update: "Update Weather",
    weather_fetching: "Fetching localized weather data...",
    weather_load_error: "Unable to load weather data",
    weather_change_location: "Change Location",
    weather_click_change: "Click to change",
    weather_low: "Low",
    weather_high: "High",
    weather_pressure: "Pressure",
    weather_forecast_7day: "7-Day Forecast",
    view_less: "View Less",
    view_all: "View All",
    weather_precip: "Precip",
    weather_crop_advisory: "Crop Advisory",
    weather_auto_updated: "Auto updated",
    weather_extreme_alert: "Extreme Alert",
    weather_warning: "Warning",
    weather_select_gp: "Select Gram Panchayat",
    // Crops & Advisory
    crop_wheat: "Wheat",
    crop_rice: "Rice",
    crop_cotton: "Cotton",
    crop_mustard: "Mustard",
    crop_sugarcane: "Sugarcane",
    disease_rust: "Yellow Rust",
    disease_blight: "Blight",
    disease_pest: "Pest Attack",
    advisory_irrigation: "Apply irrigation as per need.",
    advisory_spray: "Spray recommended pesticides.",
    advisory_harvest: "Harvest mature crops.",
    advisory_favorable: "Favorable growing conditions",
    risk_high: "High Risk",
    risk_moderate: "Moderate Risk",
    risk_low: "Low Risk",
    // Weekdays
    weekday_sunday: "Sunday",
    weekday_monday: "Monday",
    weekday_tuesday: "Tuesday",
    weekday_wednesday: "Wednesday",
    weekday_thursday: "Thursday",
    weekday_friday: "Friday",
    weekday_saturday: "Saturday",
    today: "Today",
    tomorrow: "Tomorrow",

    // Wind Directions
    wind_N: "N", wind_NNE: "NNE", wind_NE: "NE", wind_ENE: "ENE",
    wind_E: "E", wind_ESE: "ESE", wind_SE: "SE", wind_SSE: "SSE",
    wind_S: "S", wind_SSW: "SSW", wind_SW: "SW", wind_WSW: "WSW",
    wind_W: "W", wind_WNW: "WNW", wind_NW: "NW", wind_NNW: "NNW",
    // Conditions
    weather_cond_0: "Clear sky",
    weather_cond_1: "Mainly clear",
    weather_cond_2: "Partly cloudy",
    weather_cond_3: "Overcast",
    weather_cond_45: "Fog",
    weather_cond_48: "Depositing rime fog",
    weather_cond_51: "Light drizzle",
    weather_cond_53: "Moderate drizzle",
    weather_cond_55: "Dense drizzle",
    weather_cond_56: "Light freezing drizzle",
    weather_cond_57: "Dense freezing drizzle",
    weather_cond_61: "Slight rain",
    weather_cond_63: "Moderate rain",
    weather_cond_65: "Heavy rain",
    weather_cond_66: "Light freezing rain",
    weather_cond_67: "Heavy freezing rain",
    weather_cond_71: "Slight snow fall",
    weather_cond_73: "Moderate snow fall",
    weather_cond_75: "Heavy snow fall",
    weather_cond_77: "Snow grains",
    weather_cond_80: "Slight rain showers",
    weather_cond_81: "Moderate rain showers",
    weather_cond_82: "Violent rain showers",
    weather_cond_85: "Slight snow showers",
    weather_cond_86: "Heavy snow showers",
    weather_cond_95: "Thunderstorm",
    weather_cond_96: "Thunderstorm with slight hail",
    weather_cond_99: "Thunderstorm with heavy hail",

    // Digital Honour Board - Apply Online
    welcome_dhb_title: "Welcome to the Digital Honour Board Application Page. Kindly read and understand the Rules & Regulations carefully before proceeding.",
    rules_ack_label: "I have read and understood the Rules & Regulations",
    app_form_title: "Application for Displaying Profile on Digital Honour Board",
    select_gp_village: "Select your Gram Panchayat / Village",
    category_select_label: "Suggest your choice for category of Eminent Citizen",
    cat_distinguished: "Distinguished Eminent Citizen",
    cat_eminent: "Eminent Citizen",
    cat_respected: "Respected Citizen",
    cat_helper_text: "To know more about category see Rules & Regulations",
    page_level_select_label: "Select web pages where you want to display your profile",
    level_gp_page: "Gram Panchayat Page",
    level_bs_page: "Block Samiti Page",
    level_zp_page: "Zila Parishad Page",
    level_no_space: "Currently no space available for this category at the selected level.",
    level_approved_limit: "Approved: {count} / Limit: {limit}",
    personal_details_title: "Personal Details",
    placeholder_proper_name: "Your Proper Name to be Displayed",
    placeholder_father_name: "Father’s Name to be Displayed",
    placeholder_designation: "Designation / Achievement to be Displayed",
    mobile_label: "Your Mobile Number for Communication (Preferably WhatsApp)",
    placeholder_mobile: "Enter 10-digit mobile number",
    valid_label: "Valid",
    invalid_label: "Invalid",
    image_upload_label: "Upload Your Image to be Displayed",
    image_upload_helper: "Allowed formats: JPG / PNG | Max size: 200 KB",
    profile_desc_label: "Fill Your Profile to be Displayed",
    word_count_label: "{count}/{limit} words",
    select_cat_limit: "Select category to view word limit",
    placeholder_profile_desc: "Enter profile description",
    processing_fee_label: "Processing Fee to be Paid",
    fee_validity_alert: "This fee shall remain valid for a period of five years.",
    payment_section_title: "Payment Section",
    scan_qr_label: "Scan QR Code",
    pay_via_upi_btn: "Pay via UPI App",
    payment_confirm_label: "I confirm my payment",
    btn_save_draft: "Save Draft",
    btn_edit_details: "Edit Details",
    btn_final_submit: "Final Submit",
    submission_success: "Application submitted successfully! Status: Pending Review.",
    submission_error: "If you are facing any issue in payment or submission, please contact the company.",

    // Profiles - Distinguished
    desig_gazetted_officer: "Gazetted Officer",
    desig_army_officer: "Army Officer",
    desig_politician: "Politician / MLA",
    desc_gazetted_officer: "Sh. ABC, son of Sh. XYZ, has brought glory to the village, family, and community. You can display your achievements in up to 90 words here.",
    desc_army_officer: "Sh. DEF, son of Sh. UVW, serves the nation with pride. His dedication and bravery have inspired the youth of our village to serve the country.",
    desc_politician: "Sh. GHI, son of Sh. RST, is a dedicated public servant who has worked tirelessly for the development of our constituency and the welfare of its people.",

    // Profiles - Eminent
    desig_group_b_officer: "Group B Officer",
    desig_professor: "Professor",
    desig_cdlu: "CDLU Sirsa",
    desig_dsp: "DSP Police Services",
    desc_group_b_officer: "Serving as a Group B Gazetted Officer, dedicated to efficient public administration and implementing government development initiatives.",
    desc_professor: "A distinguished academician contributing to higher education, research excellence, and mentoring students for a bright future.",
    desc_cdlu: "Associated with Chaudhary Devi Lal University, Sirsa, working towards educational advancement and regional academic development.",
    desc_dsp: "Serving as Deputy Superintendent of Police, committed to maintaining law and order, ensuring public safety, and upholding justice.",

    // Profiles - Respected
    desig_teacher: "Teacher",
    desig_social_worker: "Social Worker",
    desig_police_inspector: "Police Inspector",
    desig_sports_coach: "Sports Coach",
    desig_numberdar: "Numberdar",
    desc_teacher: "Dedicated to shaping the future of the village through education and guidance.",
    desc_social_worker: "Committed to community service, cleanliness, and social welfare initiatives.",
    desc_police_inspector: "Ensuring law and order, and safety of citizens with dedication and integrity.",
    desc_sports_coach: "Training youth in sports, promoting fitness and discipline in the community.",
    desc_numberdar: "A respected community leader assisting in revenue matters and village administration.",

    // Common Profile
    profile_so: "S/o",
    profile_sample: "Profile Sample",

    // UI Interaction
    read_more: "Read More",
    read_less: "Read Less",
    login_required_like: "please login first to like the profile",
    already_liked: "You have already liked this profile",
    like_failed: "Failed to like profile",
    liked_success: "Liked!",
    login_required_share: "Please log in first to share.",
    share_failed: "Failed to share",
    shared_success: "Shared!",
    already_shared: "You have already shared this",
    link_copied: "Link copied to clipboard!",
    copy_failed: "Failed to copy link",
    cookie_consent_title: "We use cookies",
    cookie_consent_body: "We use cookies to operate the site, remember preferences, and improve performance. You can accept all, reject non-essential, or manage settings.",
    cookie_consent_accept: "Accept all",
    cookie_consent_reject: "Reject non-essential",
    cookie_consent_manage: "Manage",
    cookie_consent_manage_title: "Cookie settings",
    cookie_consent_save: "Save preferences",
    cookie_consent_close: "Close",
    cookie_cat_necessary: "Strictly necessary",
    cookie_cat_necessary_desc: "Required for core site functionality and security.",
    cookie_cat_preferences: "Preferences",
    cookie_cat_preferences_desc: "Remember language and UI choices.",
    cookie_cat_analytics: "Analytics",
    cookie_cat_analytics_desc: "Help us understand usage and improve performance.",
    cookie_cat_marketing: "Marketing",
    cookie_cat_marketing_desc: "Used to measure and personalize content (if enabled).",
    cta_nominate_title: "Celebrate Village Heroes",
    cta_nominate_body: "Do you know a citizen whose contributions deserve recognition? Nominate them for the Digital Honor Board.",
    cta_nominate_btn: "Nominate a Citizen",
    citizen_services_title: "Citizen Digital Services Portal",
    citizen_services_subtitle: "Single interface for accessing verified Central & State Government services",
    // Service Buttons
    btn_farmer: "Farmer Services",
    btn_academics: "Academics & Jobs",
    btn_certificates: "Citizen Certificates",
    btn_grievances: "Public Grievances",
    btn_travel: "Travelling Services",
    personal_dashboard: "Personal Dashboard",
    // User Profile
    complete_profile_msg: "First Complete Your Profile",
    login_prompt_msg: "Create your profile to access all services.",
    yes: "Yes",
    no: "No",
    save: "Save",
    cancel: "Cancel",
    full_name: "Full Name",
    mobile_number: "Mobile Number",
    email_label: "Email",
    address_label: "Address",
    profile_photo: "Profile photo",
    change_profile_photo: "Change profile photo",
    save_profile: "Save Profile",
    profile_preferences_title: "Preferences",
    theme_label: "Theme",
    theme_light: "Light",
    theme_dark: "Dark",
    theme_system: "System",
    font_size_label: "Font size",
    font_default: "Default",
    font_large: "Large",
    font_xlarge: "Extra large",
    panchayati_raj_title: "Panchayati Raj",
    pr_member_question: "Are you a member of Panchayati Raj?",
    pr_designation_label: "Designation",
    select_designation: "Select designation",
    designation_chairperson: "Chairperson",
    designation_vice_chairperson: "Vice-chairperson",
    designation_sarpanch: "Sarpanch",
    designation_ward_member: "Ward member",
    pr_institution_label: "Institution details",
    pr_verification_title: "Panchayati Raj Verification",
    pr_member_question2: "Are you a Panchayati Raj Member?",
    pr_status_pending: "Pending Verification",
    pr_status_verified: "Verified Member",
    pr_status_rejected: "Rejected",
    pr_designation_label2: "Designation",
    pr_designation_sarpanch: "Sarpanch",
    pr_designation_panch: "Panch",
    pr_designation_block_samiti_member: "Block Samiti Member",
    pr_designation_zila_parishad_member: "Zila Parishad Member",
    pr_designation_chairman: "Chairman",
    pr_designation_vice_chairman: "Vice Chairman",
    pr_designation_secretary: "Secretary",
    pr_designation_bdpo: "BDPO",
    pr_institution_type_label: "Institution type",
    select_institution_type: "Select institution type",
    institution_type_gp: "GP",
    institution_type_bs: "Block Samiti",
    institution_type_zp: "Zila Parishad",
    pr_institution_name_label: "Institution name",
    my_services: "My Services",
    add_service: "Add Service",
    my_documents: "My Documents",
    add_document: "Add Document",
    edit_profile: "Edit Profile",
    direct_login: "Login",
    // Quick Panels
    view_all_services: "View All Services",
    upload_new_document: "Upload New Document",
    sync_whatsapp: "Sync WhatsApp",
    clear_all: "Clear all",
    no_services_found: "No services found.",
    no_documents_uploaded: "No documents uploaded.",
    no_new_notifications: "No new notifications.",
    // Farmer Services
    farmer_services_title: "Farmer & Rural Services",
    farmer_services_subtitle: "Access schemes, subsidies, land records, and farmer advisory services in one place",
    service_farmer_id: "Farmer ID (AgriStack)",
    service_mfmb: "Meri Fasal Mera Byora",
    service_land_records: "Jamabandi / Land Records",
    service_pm_kisan: "PM-KISAN Samman Nidhi",
    service_crop_advisory: "Crop Disease & Weather Advisory",
    service_pmfby: "Crop Insurance (PMFBY)",
    service_agri_subsidies: "Agriculture Subsidies (Active Schemes)",
    service_pm_mandhan: "PM-Kisan Maandhan (Pension)",
    service_soil_health: "Soil Health Card",
    service_kisan_call: "Kisan Call Center / Advisory",
    service_agri_infra_fund: "Agri Infrastructure Fund",


    // Academic Services
    academic_services_title: "Education & Careers",
    academic_services_desc: "Find admissions, results, and job opportunities with ease.",
    academic_admissions: "Admissions",
    academic_results: "Exam Results",
    academic_jobs: "Job Vacancies",
    // Certificate Services
    certificate_services_title: "Citizen Certificates",
    certificate_services_desc: "Apply for important certificates and civic services without confusion.",
    cert_birth_death: "Birth & Death Certificate",
    cert_caste: "Caste Certificate",
    cert_residence: "Residence Certificate",
    cert_income: "Income Certificate",
    cert_family_id: "Family ID (PPP)",
    cert_birth: "Birth Certificate",
    cert_pension: "Pension Services",
    cert_aadhaar: "Aadhaar Services",
    cert_driving_license: "Driving Licence",
    cert_ration_card: "Ration Card",
    cert_voter_id: "Voter ID",
    cert_character: "Character Certificate",
    cert_unemployment: "Unemployment Allowance",
    // Grievance Services
    grievance_services_title: "Public Grievances",
    grievance_desc: "Register complaints, track requests, and get support",
    grievance_new: "Lodge Grievance",
    grievance_track: "Track Status",
    grievance_helpline: "Helpline Numbers",
    // Travel Services
    travel_services_title: "Travelling Services",
    travel_desc: "Book travel, check routes, and access transport-related services.",
    travel_bus: "Bus Services",
    travel_train: "Train Services",
    travel_routes: "Route Maps",
    // Navigation
    back_to_menu: "Back to Menu",
    back_home: "Back to Home",
    home_tooltip: "Home",
    // Online Services Info
    why_use_title: "Why Use This Portal",
    why_use_intro: "By creating **one single profile**, you get:",
    why_use_point_1: "**Unified Access**: Apply for schemes, certificates, and jobs from one place.",
    why_use_point_2: "**Secure storage**: Keep all your documents safe and accessible.",
    why_use_point_3: "**Timely notifications**: Get updates on application status and new schemes.",
    // Profile Collapsed State
    profile_prompt: "Please complete your profile to access full dashboard features",
    namaste: "Namaste",
    my_notifications: "My Notifications",
    why_use_footer: "Save time and avoid visiting multiple offices.",
    disclaimer_portal_title: "Disclaimer",
    disclaimer_portal_body: "This portal is provided only for information and facilitation. Official processing is done by respective departments.",
    how_to_use_portal_title: "How to Use This Portal",
    how_to_use_step_1: "Click on the **category tab** above (e.g., Farmer, Student).",
    how_to_use_step_2: "**Create your profile** or log in securely.",
    how_to_use_step_3: "Browse available services and **apply online**.",
    how_to_use_step_4: "Upload necessary documents and submit.",
    how_to_use_step_5: "Track status and receive certificates digitally.",
    how_to_use_footer: "Need help? Visit the Grievances tab.",
  },
  hi: {
    title: "मेरी डिजिटल पंचायत : मेरा गौरव",
    welcome_title: "हरियाणा के डिजिटल गाँव नेटवर्क में आपका स्वागत है",
    welcome_body:
      "हरियाणा के सभी 6,222 ग्राम पंचायतों का अन्वेषण करें। जानकारी, योजनाएँ, विकास अपडेट प्राप्त करें और अपनी पंचायत से ऑनलाइन जुड़ें।",
    select_district: "जिला चुनें",
    select_block_first: "पहले जिला चुनें",
    select_block: "ब्लॉक चुनें",
    select_village_first: "पहले ब्लॉक चुनें",
    select_village: "ग्राम पंचायत चुनें",
    select_level: "संस्था का प्रकार चुनें",
    search_gp_label: "ग्राम पंचायत खोजें",
    search_gp_placeholder: "ग्राम पंचायत खोजें",
    clear_search: "खोज साफ़ करें",
    search_gp_no_matches: "कोई परिणाम नहीं",
    loading: "लोड हो रहा है...",
    loading_districts: "जिले लोड हो रहे हैं...",
    no_districts_available: "कोई जिला उपलब्ध नहीं",
    no_blocks_available: "कोई ब्लॉक उपलब्ध नहीं",
    no_gram_panchayats_available: "कोई ग्राम पंचायत उपलब्ध नहीं",
    selected_panchayats: "चयनित",
    reselect_panchayat: "ग्राम पंचायत फिर से चुनें",
    remove_selection: "चयन हटाएँ",
    admin_data_load_failed: "प्रशासनिक डेटा लोड नहीं हो पाया",
    retry: "पुनः प्रयास करें",
    go: "जाएँ",
    continue: "आगे बढ़ें",
    level_zp: "जिला परिषद",
    level_bs: "खण्ड समिति",
    level_gp: "ग्राम पंचायत",
    level_zp_short_line1: "जिला",
    level_zp_short_line2: "परिषद",
    level_bs_short_line1: "खण्ड",
    level_bs_short_line2: "समिति",
    level_gp_short_line1: "ग्राम",
    level_gp_short_line2: "पंचायत",
    first_select_institution: "पहले अपनी संस्था चुनें",
    sign_in_required_title: "लॉगिन आवश्यक है",
    sign_in_required_message: "कृपया आगे बढ़ने के लिए लॉगिन करें।",
    sign_in_with_google: "लॉगिन",
    news_title: "नवीनतम",
    news_tabs_announcements: "समाचार/घोषणाएँ",
    ad_title: "विज्ञापन स्थान",
    ad_body:
      "यहाँ अपना व्यवसाय, सेवा या स्थानीय उत्पाद प्रमोट करें। संपर्क करें:",
    dashboard_title: "हरियाणा राज्य डैशबोर्ड",
    total_panchayats: "कुल पंचायतें",
    districts: "जिले",
    registered_users: "पंजीकृत उपयोगकर्ता",
    footer: "© 2025 मेरी पंचायत : मेरा गौरव. टेक मास्ट्रो डिजिटल सर्विसेज द्वारा विकसित।",
    caption_pm: "श्री नरेंद्र मोदी, प्रधानमंत्री, भारत सरकार",
    caption_cm: "श्री नायब सिंह सैनी, मुख्यमंत्री, हरियाणा सरकार",
    caption_minister: "श्री कृष्ण लाल पंवार, विकास एवं पंचायती राज मंत्री, हरियाणा सरकार",
    cm_name: "श्री नायब सिंह सैनी",
    cm_designation: "मुख्यमंत्री, हरियाणा सरकार",
    pm_name: "श्री कृष्ण लाल पंवार",
    pm_designation: "विकास एवं पंचायती राज मंत्री",
    panch_ward_label: "पंच वार्ड नं.",
    block_samitis: "खण्ड समितियाँ",
    data_source_label: "स्रोत",
    data_source_value: "आधिकारिक हरियाणा पंचायती राज प्रशासनिक अभिलेख (2025)",
    level_header_tagline: "आइए आपकी ग्राम पंचायत का भ्रमण करें",
    sarpanch_of_village: "ग्राम पंचायत {village} के सरपंच",
    sarpanch_placeholder_aria: "सरपंच प्लेसहोल्डर",
    sarpanch_title: "सरपंच",
    panch_ward_prefix: "पंच वार्ड",
    block_samiti_member_label: "खण्ड समिति सदस्य",
    zila_parishad_member_label: "जिला परिषद सदस्य",
    previous_gram_panchayat: "पूर्व ग्राम पंचायत",
    previous_block_samiti: "पूर्व खण्ड समिति",
    previous_zila_parishad: "पूर्व जिला परिषद",
    consensus_label: "* सर्वसम्मति से निर्वाचित",
    correction_link_text: "#नाम में सुधार अपडेट करने के लिए यहाँ क्लिक करें",
    correction_name_update_template: "ग्राम पंचायत {gp}/ब्लॉक {block}/जिला {district} के वेबपेज में नाम अपडेट करना आवश्यक है, जैसा सुझाव दिया गया है..",
    show_images: "तस्वीरें दिखाएं",
    hide_images: "तस्वीरें छिपाएं",
    data_unavailable: "डाटा उपलब्ध नहीं है",
    ward_data_unavailable_btn: "डाटा उपलब्ध नहीं है",
    ward_whatsapp_template: "मैं ग्राम पंचायत {gp}, ब्लॉक {block}, जिला {district} के वार्ड नंबर {ward} का पंच हूँ। कृपया वेबसाइट पर मेरा नाम और पिता/पति का नाम अपडेट करें।",
    prev_body_label: "पिछला {level}",
    curr_body_label: "वर्तमान {level}",
    vice_chairperson_title: "उपाध्यक्ष",
    vice_chairperson_zp_line: "उपाध्यक्ष, जिला परिषद, {parishad}",
    vice_chairperson_bs_line: "उपाध्यक्ष, खण्ड समिति, {samiti}",
    whatsapp_image_request_template: "मैं, '{name}', '{designation}', ग्राम पंचायत '{gp}', ब्लॉक '{block}', जिला '{district}' इस वेबसाइट पर अपनी फोटो लगवाना चाहता/चाहती हूं। कृपया मुझे इसके बारे में और जानकारी दें। धन्यवाद",
    whatsapp_former_prefix: "भूतपूर्व ",
    whatsapp_name_missing: "नाम उपलब्ध नहीं",
    whatsapp_location_missing: "उपलब्ध नहीं",
    click_to_display_image: "अपनी तस्वीर दिखाने के लिए यहां क्लिक करें",
    image_prompt_l1: "अपनी तस्वीर",
    image_prompt_l2: "दिखाने के लिए",
    image_prompt_l3: "यहां क्लिक करें",
    // Chairperson caption lines and labels
    chairperson_title: "प्रधान",
    chairperson_zp_line: "प्रधान, जिला परिषद, {parishad}",
    chairperson_bs_line: "प्रधान, खण्ड समिति, {samiti}",
    unknown_label: "अज्ञात",
    // Welcome message variants for Gram Panchayat subpage
    dropdown_welcome_msg: "ग्राम पंचायत {village} में आपका स्वागत है",
    welcome_to_gp: "ग्राम पंचायत में आपका स्वागत है",
    welcome_gp_main: "ग्राम पंचायत {village} में आपका स्वागत है",
    welcome_loc_suffix: "({district})",
    welcome_gp_heading: "ग्राम पंचायत {village} में आपका स्वागत है",
    welcome_dynamic_loc: "{village} , {block} , {district} में आपका स्वागत है",
    welcome_bs_heading: "खण्ड समिति {block} में आपका स्वागत है",
    welcome_zp_heading: "जिला परिषद {district} में आपका स्वागत है",
    institution_gp_heading: "ग्राम पंचायत {village}",
    institution_bs_heading: "खण्ड समिति {block}",
    institution_zp_heading: "जिला परिषद {district}",
    gp_location_line: "{district} · {block}",
    latest_updates_title: "नवीनतम अपडेट",
    gp_not_found: "ग्राम पंचायत नहीं मिली",
    block_not_found: "ब्लॉक नहीं मिला",
    district_shard_not_found: "जिला डेटा नहीं मिला",
    failed_to_load_gp_data: "ग्राम पंचायत डेटा लोड करने में विफल",
    error: "त्रुटि",
    dismiss: "खारिज करें",
    back: "वापस",
    subtitle_farmer: "योजनाओं, सब्सिडी, भूमि रिकॉर्ड और ग्रामीण सेवाओं तक पहुंच प्राप्त करें",
    subtitle_academics: "प्रवेश, परीक्षा, परिणाम और नौकरी के अवसर आसानी से खोजें।",
    subtitle_certificates: "बिना किसी भ्रम के महत्वपूर्ण प्रमाण पत्रों और नागरिक सेवाओं के लिए आवेदन करें।",
    subtitle_grievances: "शिकायतें दर्ज करें, अनुरोधों को ट्रैक करें और सहायता प्राप्त करें",
    subtitle_travel: "यात्रा बुक करें, मार्ग जांचें और परिवहन संबंधी सेवाओं तक पहुंचें।",
    // Quick Links Tabs
    tab_weather_gp: "गाँव का मौसम",
    tab_weather_bs: "ब्लॉक का मौसम",
    tab_weather_zp: "जिले का मौसम",
    tab_services: "ऑनलाइन सेवाएँ",
    tab_eminent_gp: "प्रमुख व्यक्ति",
    tab_eminent_bs: "ब्लॉक प्रमुख व्यक्ति",
    tab_eminent_zp: "जिला प्रमुख व्यक्ति",
    honour_board_gp: "ग्राम डिजिटल सम्मान बोर्ड",
    honour_board_bs: "ब्लॉक डिजिटल सम्मान बोर्ड",
    honour_board_zp: "जिला डिजिटल सम्मान बोर्ड",
    apply_online: "ऑनलाइन आवेदन",
    already_applied: "पहले से आवेदन किया गया",
    apply_now: "अभी आवेदन करें",
    rules_regulations: "नियम और विनियम",

    tab_community_gp: "संवाद",
    tab_community_bs: "ब्लॉक समुदाय",
    tab_community_zp: "जिला समुदाय",
    tab_reels: "रीलग्राम",
    tab_music: "मेरा संगीत",
    tab_village_hub: "विलेज हब",
    tab_tour_gp: "गाँव की सैर",
    tab_tour_bs: "ब्लॉक की सैर",
    tab_tour_zp: "जिले की सैर",
    tab_voter: "मतदाता और चुनाव",
    footer_services_title: "सेवाएँ",
    footer_policies_title: "हमारी नीतियाँ",
    footer_connect_title: "हमसे जुड़ें",
    footer_tagline: "डिजिटल शासन के माध्यम से गांवों को सशक्त बनाना",
    footer_total_visitors: "कुल आगंतुक",
    footer_total_views: "कुल दृश्य",
    footer_institution_views: "इस संस्था के दृश्य",
    footer_policy_privacy: "गोपनीयता नीति",
    footer_policy_terms: "उपयोग की शर्तें",
    footer_policy_cookie: "कुकी नीति",
    footer_policy_gdpr: "जीडीपीआर नीति",
    footer_policy_refund: "रिफंड नीति",
    footer_policy_accessibility: "सुलभता नीति",
    footer_policy_data_usage: "डेटा उपयोग नीति",
    policy_effective_date: "प्रभावी तिथि",
    policy_last_updated: "अंतिम अद्यतन",
    policy_back_home: "होम पर वापस जाएँ",
    policy_not_found: "नीति उपलब्ध नहीं है",
    footer_whatsapp: "व्हाट्सएप",
    footer_copyright: "© 2026 Digital Panchayat Mission | सर्वाधिकार सुरक्षित",
    footer_powered_by: "Tech Maestro Digital Services द्वारा संचालित",
    footer_nav_home: "होम",
    footer_nav_weather: "मौसम",
    footer_nav_online_services: "ऑनलाइन सेवाएँ",
    footer_nav_village_hub: "विलेज हब",
    footer_nav_village_tour: "गाँव की सैर",
    footer_nav_samvaad: "संवाद",
    footer_nav_my_music: "मेरा संगीत",
    footer_nav_reelgram: "रीलग्राम",
    footer_nav_elections: "चुनाव",
    // Quick Links Tooltips
    tab_weather_gp_tooltip: "गाँव का विस्तृत मौसम पूर्वानुमान देखें",
    tab_weather_bs_tooltip: "ब्लॉक का विस्तृत मौसम पूर्वानुमान देखें",
    tab_weather_zp_tooltip: "जिले का विस्तृत मौसम पूर्वानुमान देखें",
    tab_services_tooltip: "ऑनलाइन सरकारी सेवाओं तक पहुँचें",
    tab_eminent_gp_tooltip: "गाँव के प्रतिष्ठित व्यक्तियों को देखें",
    tab_eminent_bs_tooltip: "ब्लॉक के प्रतिष्ठित व्यक्तियों को देखें",
    tab_eminent_zp_tooltip: "जिले के प्रतिष्ठित व्यक्तियों को देखें",
    tab_community_gp_tooltip: "संवाद से जुड़ें",
    tab_community_bs_tooltip: "ब्लॉक के समुदाय से जुड़ें",
    tab_community_zp_tooltip: "जिले के समुदाय से जुड़ें",
    tab_reels_tooltip: "स्थानीय लघु वीडियो देखें",
    tab_music_tooltip: "स्थानीय संगीत सुनें",
    tab_village_hub_tooltip: "विलेज हब और उससे जुड़ी प्रमुख जानकारी देखें",
    vf_village_hub: "विलेज हब",
    vf_nav_hub: "ग्राम चर्चा",
    vf_nav_notice: "पंचायत सूचना",
    vf_nav_need: "सेवा आवश्यकता",
    vf_notifications_soon: "सूचनाएँ जल्द आएंगी",
    vf_create_post: "पोस्ट बनाएँ",
    vf_choose_category: "श्रेणी चुनें",
    vh_choose_category: "पोस्ट श्रेणी चुनें",
    vh_choose_option: "पोस्ट कैसे बनाएं",
    vh_option_upload: "अपलोड",
    vh_option_upload_desc: "अपने डिवाइस से फोटो, वीडियो या दस्तावेज़ अपलोड करें।",
    vh_option_fresh: "नई पोस्ट बनाएं",
    vh_option_fresh_desc: "कैप्शन लिखें, हैशटैग जोड़ें, स्थान टैग करें, मीडिया संपादित करें और शेड्यूल करें।",
    vh_option_live: "लाइव स्ट्रीम",
    vh_option_live_desc: "कैमरा से लाइव-स्टाइल रिकॉर्डिंग करें, शीर्षक और गोपनीयता सेट करें।",
    vh_add_media: "मीडिया जोड़ें",
    vh_pick_files: "फाइलें चुनें",
    vh_media_too_large: "एक या अधिक फाइलें बहुत बड़ी हैं।",
    vh_camera_denied: "कैमरा अनुमति नहीं मिली या उपलब्ध नहीं है।",
    vh_live_not_supported: "इस डिवाइस पर लाइव रिकॉर्डिंग समर्थित नहीं है।",
    vh_location_tag: "स्थान टैग (वैकल्पिक)",
    vh_location_placeholder: "स्थान/लैंडमार्क लिखें",
    vh_scheduling: "शेड्यूल (वैकल्पिक)",
    vh_scheduling_note: "यदि आपके बैकएंड में शेड्यूलिंग समर्थित नहीं है, तो पोस्ट तुरंत प्रकाशित होगी।",
    vh_media_edit: "मीडिया संपादन",
    vh_crop: "क्रॉप",
    vh_filter: "फ़िल्टर",
    vh_filter_none: "कोई नहीं",
    vh_filter_warm: "वार्म",
    vh_filter_mono: "मोनो",
    vh_filter_vivid: "विविड",
    vh_live_setup: "लाइव सेटअप",
    vh_live_title: "लाइव शीर्षक",
    vh_live_description: "विवरण",
    vh_privacy_public: "सार्वजनिक",
    vh_privacy_village: "गाँव",
    vh_privacy_private: "निजी",
    vh_camera_start: "कैमरा शुरू करें",
    vh_camera_stop: "कैमरा बंद करें",
    vh_live_start: "रिकॉर्डिंग शुरू",
    vh_live_stop: "रिकॉर्डिंग रोकें",
    vh_fmt_bold: "बोल्ड",
    vh_fmt_italic: "इटैलिक",
    vh_fmt_underline: "अंडरलाइन",
    vh_err_permission: "आपको पोस्ट करने की अनुमति नहीं है।",
    vh_err_network: "नेटवर्क त्रुटि। कृपया दोबारा प्रयास करें।",
    vh_err_sign_in: "पोस्ट करने के लिए लॉगिन करें।",
    vh_err_unknown: "पोस्ट नहीं हो सका। कृपया दोबारा प्रयास करें।",
    vh_err_category_required: "कृपया एक श्रेणी चुनें।",
    vh_err_bucket_missing: "स्टोरेज बकेट village-feed-media मौजूद नहीं है।",
    vf_message: "संदेश",
    vf_whats_happening: "आज आपके गाँव में क्या हो रहा है?",
    vh_sticky_prompt: "आज आपके गाँव में क्या हो रहा है ?",
    vh_post_now: "पोस्ट करें",
    vh_create_post: "पोस्ट बनाएँ",
    vh_language_toggle: "भाषा",
    vh_language_hi: "हिन्दी",
    vh_language_pa: "ਪੰਜਾਬੀ",
    vh_language_hi_short: "हि",
    vh_language_pa_short: "ਪੰ",
    vh_profile_missing_toast: "पहले अपनी प्रोफ़ाइल पूरी करें (कुछ विवरण गायब हैं)।",
    vf_post: "पोस्ट करें",
    vf_posting: "पोस्ट हो रहा है...",
    vf_uploading: "अपलोड हो रहा है...",
    vf_posted: "पोस्ट हो गया",
    vf_posted_success: "सफलतापूर्वक पोस्ट हो गया",
    vf_post_failed: "पोस्ट नहीं हो सका",
    vf_add_media: "फोटो, वीडियो या आवाज़ जोड़ें",
    vf_text: "टेक्स्ट",
    vf_photo: "फोटो",
    vf_video: "वीडियो",
    vf_audio: "आवाज़",
    vf_stop: "रोकें",
    vf_remove_audio: "आवाज़ हटाएँ",
    vf_optional: "वैकल्पिक",
    vf_tags: "टैग",
    vf_add_tags: "टैग जोड़ें (वैकल्पिक)",
    vf_buy_sell_details: "खरीद/बिक्री विवरण",
    vf_item_name: "सामान का नाम",
    vf_item_required: "सामान का नाम आवश्यक है",
    vf_item: "सामान",
    vf_price: "कीमत",
    vf_price_unknown: "कीमत नहीं लिखी",
    vf_negotiable: "बातचीत योग्य",
    vf_emergency: "आपातकाल",
    vf_emergency_details: "आपातकाल विवरण",
    vf_urgency: "तत्कालता",
    vf_urgency_high: "बहुत जरूरी",
    vf_urgency_medium: "मध्यम",
    vf_urgency_low: "कम",
    vf_sell_item: "सामान बेचें",
    vf_need_help: "मदद चाहिए",
    vf_agri_update: "कृषि",
    vf_login_prompt_title: "अपने गाँव के फ़ीड से जुड़ें",
    vf_login_prompt_text: "पोस्ट, लाइक और सेव करने के लिए लॉगिन करें।",
    vf_login_to_interact: "इंटरैक्ट करने के लिए लॉगिन करें",
    vf_filter_all: "सभी",
    vf_filter_agriculture: "कृषि",
    vf_filter_buy_sell: "खरीद/बिक्री",
    vf_filter_emergency: "आपातकाल",
    vf_filter_events: "कार्यक्रम",
    vf_filter_education: "शिक्षा",
    vf_filter_labour: "मजदूरी",
    vf_load_failed: "फ़ीड लोड नहीं हो सका",
    vf_load_failed_hint: "अगर यह पहली बार है, तो Village Feed की टेबल अभी बनी नहीं हो सकती।",
    vf_empty_title: "अभी कोई पोस्ट नहीं",
    vf_empty_text: "अपने गाँव का पहला अपडेट साझा करें।",
    vf_first_post_title: "अपनी ग्राम पंचायत में सबसे पहले पोस्ट करें।",
    vf_first_post_text: "एक स्थानीय अपडेट शुरू करें ताकि आपका पंचायत जुड़ा रहे।",
    vf_empty_cta_1: "पहला गाँव अपडेट साझा करें",
    vf_empty_cta_2: "कृषि अपडेट पोस्ट करें",
    vf_empty_cta_3: "स्थानीय रूप से बेचें",
    vf_end: "आपने सब देख लिया",
    vf_scope_all: "सभी",
    vf_scope_gp: "मेरी पंचायत",
    vf_scope_nearby: "आस-पास",
    vf_scope_block: "ब्लॉक",
    vf_scope_district: "ज़िला",
    vf_scope_state: "राज्य",
    vf_follow: "फॉलो",
    vf_following: "फ़ॉलोइंग",
    vh_filter_all: "सभी",
    vh_filter_my_panchayat: "मेरी पंचायत",
    vh_filter_nearby: "आस-पास",
    vh_filter_block: "ब्लॉक",
    vh_filter_district: "जिला",
    vh_filter_state: "राज्य",
    vh_filter_haryana: "हरियाणा",
    vh_nearby_loading: "आस-पास की Village Hub पोस्ट लोड हो रही हैं...",
    vh_nearby_permission_required: "आस-पास की Village Hub पोस्ट देखने के लिए लोकेशन अनुमति आवश्यक है।",
    vh_nearby_location_unavailable: "आपकी वर्तमान लोकेशन प्राप्त नहीं हो सकी। कृपया फिर से प्रयास करें।",
    vh_nearby_no_posts: "10 किमी के भीतर कोई Village Hub पोस्ट नहीं मिली।",
    vf_villager: "ग्रामवासी",
    vf_now: "अभी",
    vf_time_m: "मि",
    vf_time_h: "घं",
    vf_time_d: "दि",
    vf_post_aria: "ग्राम पोस्ट",
    vf_action_failed: "क्रिया विफल",
    vf_share: "शेयर",
    vf_share_whatsapp: "व्हाट्सएप",
    vf_share_facebook: "फेसबुक",
    vf_share_native: "शेयर करें",
    vf_share_instagram: "इंस्टाग्राम",
    vf_comments: "टिप्पणियाँ",
    vf_share_title: "विलेज फ़ीड",
    vf_native_share: "शेयर",
    vf_copy_link: "लिंक कॉपी करें",
    vf_post_image: "पोस्ट छवि",
    vf_open_document: "दस्तावेज़ खोलें",
    vf_verified: "सत्यापित",
    vf_post_time: "पोस्ट समय",
    vf_categories_loading: "श्रेणियाँ लोड हो रही हैं...",
    vf_categories_load_failed: "श्रेणियाँ लोड नहीं हो सकीं",
    vf_categories_load_empty: "श्रेणियाँ लोड नहीं हो सकीं (0)। यह अक्सर सुरक्षा नीति के कारण होता है।",
    vf_audio_not_supported: "इस डिवाइस पर आवाज़ रिकॉर्ड नहीं हो रही।",
    vf_section_your_gp: "आपकी ग्राम पंचायत",
    vf_section_selected_gp: "चयनित ग्राम पंचायत",
    vf_section_nearby_gp: "आस-पास की ग्राम पंचायतें",
    vf_section_your_block: "आपका ब्लॉक",
    vf_section_your_district: "आपका ज़िला",
    vf_section_across_haryana: "हरियाणा भर में",
    vf_coming_soon: "यह सेक्शन जल्द आएगा।",
    vf_category_general: "सामान्य",
    vf_category_buy_sell: "खरीद/बिक्री",
    vf_category_agriculture: "कृषि",
    vf_category_emergency: "आपातकाल",
    vf_category_event: "कार्यक्रम",
    vf_category_events: "कार्यक्रम",
    vf_category_labour: "मजदूरी",
    vf_category_missing: "गुमशुदा",
    vf_category_medical: "चिकित्सा मदद",
    vf_category_education: "शिक्षा",
    vf_category_transport: "परिवहन",
    vf_category_news: "समाचार",
    vf_category_entertainment: "मनोरंजन",
    vf_category_sale_purchase: "खरीद/बिक्री",
    vf_category_advertisement: "विज्ञापन",
    vf_category_others: "अन्य",
    vh_profile_required_title: "पोस्ट बनाने के लिए प्रोफ़ाइल पूरी करें",
    vh_profile_required_desc: "कृपया नीचे दिए गए आवश्यक विवरण भरें, फिर दोबारा पोस्ट बनाएं।",
    vh_missing_full_name: "पूरा नाम आवश्यक",
    vh_missing_gp: "ग्राम पंचायत आवश्यक",
    vh_missing_phone_verified: "सत्यापित मोबाइल आवश्यक",
    vh_missing_unknown: "कुछ विवरण गायब हैं",
    vf_onboard_1_title: "गाँव के अपडेट साझा करें",
    vf_onboard_1_text: "रोज़ाना अपडेट, कार्यक्रम और घोषणाएँ पोस्ट करें।",
    vf_onboard_2_title: "स्थानीय खरीद/बिक्री",
    vf_onboard_2_text: "पास में सामान बेचें और ज़रूरी चीज़ें खोजें।",
    vf_onboard_3_title: "तुरंत मदद पाएँ",
    vf_onboard_3_text: "आपातकाल, चिकित्सा मदद या ज़रूरी आवश्यकता पोस्ट करें।",
    vf_onboard_4_title: "पंचायत से जुड़ें",
    vf_onboard_4_text: "सूचनाएँ और ज़रूरी अपडेट देखें।",
    vf_skip: "छोड़ें",
    vf_back: "वापस",
    vf_next: "आगे",
    vf_start: "शुरू करें",
    vf_comments_title: "टिप्पणियाँ",
    vf_comment_placeholder: "टिप्पणी लिखें...",
    vf_send: "भेजें",
    vf_no_comments: "अभी कोई टिप्पणी नहीं। सबसे पहले टिप्पणी करें।",
    vf_load_more_comments: "पुरानी टिप्पणियाँ देखें",
    vf_comments_failed: "टिप्पणियाँ लोड नहीं हो सकीं",
    vf_comment_failed: "टिप्पणी नहीं भेजी जा सकी",
    vf_login_to_comment: "टिप्पणी के लिए लॉगिन करें",
    tab_tour_gp_tooltip: "गाँव की आभासी सैर करें",
    tab_tour_bs_tooltip: "ब्लॉक की आभासी सैर करें",
    tab_tour_zp_tooltip: "जिले की आभासी सैर करें",
    tab_voter_tooltip: "मतदाता और चुनाव जानकारी देखें",
    voter_list_title: "मतदाता सूची",
    voter_list_desc: "अपने क्षेत्र की नवीनतम मतदाता सूची डाउनलोड करें।",
    download_pdf: "पीडीएफ डाउनलोड करें",
    election_comm_title: "चुनाव आयोग",
    election_comm_desc: "आधिकारिक चुनाव आयोग पोर्टल पर जाएं।",
    visit_website: "वेबसाइट पर जाएं",
    important_info: "महत्वपूर्ण सूचना",
    election_dates_msg: "आगामी पंचायत चुनावों की तिथियों की घोषणा जल्द ही की जाएगी। कृपया अपडेट के लिए नियमित रूप से जांचें।",
    reel_label: "रील {index}",
    music_track_label: "लोक गीत ट्रैक {index}",
    music_artist_label: "स्थानीय कलाकार",
    tour_site_label: "ऐतिहासिक स्थल {index}",
    tour_site_desc: "घूमने के लिए एक सुंदर स्थान।",
    // Weather
    weather_feels_like: "महसूस हो रहा है",
    weather_now: "अभी",
    weather_hourly_forecast: "प्रति घंटा पूर्वानुमान",
    weather_7_day_forecast: "7-दिवसीय पूर्वानुमान",
    weather_alert: "मौसम चेतावनी",
    weather_alert_rain_desc: "बारिश की संभावना है। यदि आवश्यक हो तो कृपया फसलों की सुरक्षा सुनिश्चित करें।",
    weather_search_placeholder: "जिला या ब्लॉक खोजें...",
    weather_recent: "हाल ही में",
    weather_no_matches: "कोई परिणाम नहीं मिला",
    weather_search_prompt: "मौसम देखने के लिए किसी स्थान को खोजें।",
    weather_humidity: "नमी",
    weather_wind: "हवा",
    weather_sunrise: "सूर्योदय",
    weather_sunset: "सूर्यास्त",
    weather_select_location: "स्थान चुनें",
    weather_unknown: "अज्ञात",
    weather_clear_sky: "साफ आसमान",
    weather_partly_cloudy: "आंशिक रूप से बादल",
    weather_foggy: "कोहरा",
    weather_rainy: "बारिश",
    weather_snow: "बर्फबारी",
    weather_showers: "बौछारें",
    weather_thunderstorm: "आंधी-तूफान",
    // Weather Advanced
    weather_precipitation: "वर्षा",
    weather_chance: "संभावना",
    weather_wind_direction: "हवा की दिशा",
    weather_disease_risk: "रोग का खतरा",
    weather_wind_conditions: "हवा और स्थितियां",
    weather_alert_heatwave_warning: "लू की चेतावनी",
    weather_alert_heatwave_warning_msg: "हाइड्रेटेड रहें, दोपहर की धूप से बचें",
    weather_alert_severe_heatwave: "गंभीर लू",
    weather_alert_severe_heatwave_msg: "अत्यधिक गर्मी! घर के अंदर रहें।",
    weather_alert_coldwave_warning: "शीतलहर की चेतावनी",
    weather_alert_coldwave_warning_msg: "ठंड का प्रकोप। फसलों और पशुधन की रक्षा करें।",
    weather_alert_rain_risk: "मध्यम बारिश का खतरा",
    weather_alert_rain_risk_msg: "खेतों से जल निकासी सुनिश्चित करें",
    weather_alert_rain_advisory: "हल्की बारिश की सलाह",
    weather_alert_rain_advisory_msg: "हल्की बारिश संभव। फसल की नमी की निगरानी करें।",
    weather_alert_storm_severe: "गंभीर तूफान की चेतावनी",
    weather_alert_storm_severe_msg: "तेज हवाएं और बिजली गिरने की संभावना। सुरक्षित स्थान पर रहें।",
    weather_alert_storm_advisory: "हवा की सलाह",
    weather_alert_storm_advisory_msg: "तेज हवाएं चलने की उम्मीद। ढीले ढांचों को सुरक्षित करें।",
    weather_forecast_today: "आज",
    weather_forecast_tomorrow: "कल",
    weather_cond_sunny: "धूप",
    weather_cond_cloudy: "बादल छाए रहेंगे",
    weather_cond_broken_clouds: "बिखरे हुए बादल",
    weather_cond_overcast: "घने बादल",
    weather_cond_rain: "बारिश",
    weather_cond_storm: "तूफान",
    weather_cond_clear_sky: "साफ आसमान",
    weather_cond_partly_cloudy: "आंशिक रूप से बादल",
    weather_cond_light_rain: "हल्की बारिश",
    weather_cond_moderate_rain: "मध्यम बारिश",
    weather_cond_thunderstorm: "आंधी-तूफान",
    weather_location_error: "{block}, {district} के लिए स्थान निर्देशांक नहीं मिले। डिफ़ॉल्ट का उपयोग किया जा रहा है।",
    weather_gis_file_error: "स्थान डेटाबेस फ़ाइल गायब है या खराब हो गई है।",
    weather_gis_district_not_found: "स्थान डेटाबेस में जिला नहीं मिला: {district}।",
    weather_gis_filter_invalid: "जिले के लिए स्थान डेटाबेस प्रविष्टि अमान्य है: {district}।",
    weather_gis_invalid_coords: "जिले के लिए अमान्य निर्देशांक मिले: {district}।",
    weather_light_showers: "हल्की बौछारें",
    weather_expected: "अपेक्षित",
    weather_gis_error: "{block}, {district} के लिए स्थान निर्देशांक नहीं मिले। डिफ़ॉल्ट का उपयोग किया जा रहा है।",
    weather_gis_load_error: "स्थान डेटाबेस लोड करने में विफल।",
    weather_fetch_error: "मौसम डेटा प्राप्त करने में असमर्थ। कृपया बाद में पुनः प्रयास करें।",
    weather_update: "मौसम अपडेट करें",
    weather_fetching: "स्थानीय मौसम डेटा प्राप्त किया जा रहा है...",
    weather_load_error: "मौसम डेटा लोड करने में असमर्थ",
    weather_change_location: "स्थान बदलें",
    weather_click_change: "बदलने के लिए क्लिक करें",
    weather_low: "न्यूनतम",
    weather_high: "अधिकतम",
    weather_pressure: "दबाव",
    weather_forecast_7day: "7-दिन का पूर्वानुमान",
    view_less: "कम देखें",
    view_all: "सभी देखें",
    weather_precip: "वर्षा",
    weather_crop_advisory: "फसल सलाह",
    weather_auto_updated: "स्वतः अपडेट",
    weather_extreme_alert: "चरम चेतावनी",
    weather_warning: "चेतावनी",
    weather_select_gp: "ग्राम पंचायत चुनें",
    // Crops & Advisory
    crop_wheat: "गेहूँ",
    crop_rice: "धान",
    crop_cotton: "कपास",
    crop_mustard: "सरसों",
    crop_sugarcane: "गन्ना",
    disease_rust: "पीला रतुआ",
    disease_blight: "झुलसा रोग",
    disease_pest: "कीट हमला",
    advisory_irrigation: "आवश्यकतानुसार सिंचाई करें।",
    advisory_spray: "अनुशंसित कीटनाशकों का छिड़काव करें।",
    advisory_harvest: "पकी हुई फसल की कटाई करें।",
    advisory_favorable: "फसल विकास की अनुकूल परिस्थितियाँ",
    risk_high: "उच्च जोखिम",
    risk_moderate: "मध्यम जोखिम",
    risk_low: "कम जोखिम",
    // Wind Directions
    wind_N: "उ", wind_NNE: "उ-उ-पू", wind_NE: "उ-पू", wind_ENE: "पू-उ-पू",
    wind_E: "पू", wind_ESE: "पू-द-पू", wind_SE: "द-पू", wind_SSE: "द-द-पू",
    wind_S: "द", wind_SSW: "द-द-प", wind_SW: "द-प", wind_WSW: "प-द-प",
    wind_W: "प", wind_WNW: "पउ", wind_NW: "उ-प", wind_NNW: "उ-उ-प",
    // Weekdays
    weekday_sunday: "रविवार",
    weekday_monday: "सोमवार",
    weekday_tuesday: "मंगलवार",
    weekday_wednesday: "बुधवार",
    weekday_thursday: "गुरुवार",
    weekday_friday: "शुक्रवार",
    weekday_saturday: "शनिवार",
    weekday_today: "आज",
    weekday_tomorrow: "कल",
    // Conditions
    weather_cond_0: "साफ आसमान",
    weather_cond_1: "मुख्य रूप से साफ",
    weather_cond_2: "आंशिक रूप से बादल",
    weather_cond_3: "बादल छाए रहेंगे",

    weather_cond_foggy: "कोहरा",



    weather_cond_45: "कोहरा",
    weather_cond_48: "जमा देने वाला कोहरा",
    weather_cond_51: "हल्की बूंदाबांदी",
    weather_cond_53: "मध्यम बूंदाबांदी",
    weather_cond_55: "घनी बूंदाबांदी",
    weather_cond_56: "हल्की जमा देने वाली बूंदाबांदी",
    weather_cond_57: "घनी जमा देने वाली बूंदाबांदी",
    weather_cond_61: "हल्की बारिश",
    weather_cond_63: "मध्यम बारिश",
    weather_cond_65: "भारी बारिश",
    weather_cond_66: "हल्की बर्फीली बारिश",
    weather_cond_67: "भारी बर्फीली बारिश",
    weather_cond_71: "हल्की बर्फबारी",
    weather_cond_73: "मध्यम बर्फबारी",
    weather_cond_75: "भारी बर्फबारी",
    weather_cond_77: "बर्फ के दाने",
    weather_cond_80: "हल्की बारिश की बौछारें",
    weather_cond_81: "मध्यम बारिश की बौछारें",
    weather_cond_82: "तेज बारिश की बौछारें",
    weather_cond_85: "हल्की बर्फबारी की बौछारें",
    weather_cond_86: "भारी बर्फबारी की बौछारें",
    weather_cond_95: "आंधी-तूफान",
    weather_cond_96: "हल्के ओलों के साथ आंधी",
    weather_cond_99: "भारी ओलों के साथ आंधी",

    // Digital Honour Board - Apply Online
    welcome_dhb_title: "डिजिटल सम्मान बोर्ड आवेदन पृष्ठ पर आपका स्वागत है। कृपया आगे बढ़ने से पहले नियमों और विनियमों को ध्यान से पढ़ें और समझें।",
    rules_ack_label: "मैंने नियमों और विनियमों को पढ़ और समझ लिया है",
    app_form_title: "डिजिटल सम्मान बोर्ड पर प्रोफ़ाइल प्रदर्शित करने के लिए आवेदन",
    select_gp_village: "अपनी ग्राम पंचायत / गाँव चुनें",
    category_select_label: "प्रतिष्ठित नागरिक की श्रेणी के लिए अपना विकल्प सुझाएं",
    cat_distinguished: "विशिष्ट प्रतिष्ठित नागरिक",
    cat_eminent: "प्रतिष्ठित नागरिक",
    cat_respected: "सम्मानित नागरिक",
    cat_helper_text: "श्रेणी के बारे में अधिक जानने के लिए नियम और विनियम देखें",
    page_level_select_label: "वे वेब पेज चुनें जहाँ आप अपनी प्रोफ़ाइल प्रदर्शित करना चाहते हैं",
    level_gp_page: "ग्राम पंचायत पेज",
    level_bs_page: "ब्लॉक समिति पेज",
    level_zp_page: "जिला परिषद पेज",
    level_no_space: "वर्तमान में चयनित स्तर पर इस श्रेणी के लिए कोई स्थान उपलब्ध नहीं है।",
    level_approved_limit: "स्वीकृत: {count} / सीमा: {limit}",
    personal_details_title: "व्यक्तिगत विवरण",
    placeholder_proper_name: "प्रदर्शित किया जाने वाला आपका सही नाम",
    placeholder_father_name: "पिता का नाम (प्रदर्शित करने के लिए)",
    placeholder_designation: "पदनाम / उपलब्धि (प्रदर्शित करने के लिए)",
    mobile_label: "संचार के लिए आपका मोबाइल नंबर (प्राथमिकता व्हाट्सएप)",
    placeholder_mobile: "10 अंकों का मोबाइल नंबर दर्ज करें",
    valid_label: "मान्य",
    invalid_label: "अमान्य",
    image_upload_label: "प्रदर्शित की जाने वाली अपनी छवि अपलोड करें",
    image_upload_helper: "अनुमत प्रारूप: JPG / PNG | अधिकतम आकार: 200 KB",
    profile_desc_label: "प्रदर्शित की जाने वाली अपनी प्रोफ़ाइल भरें",
    word_count_label: "{count}/{limit} शब्द",
    select_cat_limit: "शब्द सीमा देखने के लिए श्रेणी चुनें",
    placeholder_profile_desc: "प्रोफ़ाइल विवरण दर्ज करें",
    processing_fee_label: "भुगतान की जाने वाली प्रसंस्करण शुल्क",
    fee_validity_alert: "यह शुल्क पांच वर्ष की अवधि के लिए वैध रहेगा।",
    payment_section_title: "भुगतान अनुभाग",
    scan_qr_label: "QR कोड स्कैन करें",
    pay_via_upi_btn: "UPI ऐप के माध्यम से भुगतान करें",
    payment_confirm_label: "मैं अपने भुगतान की पुष्टि करता हूँ",
    btn_save_draft: "ड्राफ्ट सहेजें",
    btn_edit_details: "विवरण संपादित करें",
    btn_final_submit: "अंतिम सबमिट",
    submission_success: "आवेदन सफलतापूर्वक सबमिट किया गया! स्थिति: समीक्षा लंबित।",
    submission_error: "यदि आपको भुगतान या सबमिशन में कोई समस्या आ रही है, तो कृपया कंपनी से संपर्क करें।",
    upi_scan_option: "UPI स्कैन विकल्प",
    upi_payment_link: "UPI भुगतान लिंक",

    // Profiles - Distinguished
    desig_gazetted_officer: "राजपत्रित अधिकारी",
    desig_army_officer: "सेना अधिकारी",
    desig_politician: "राजनेता / विधायक",
    desc_gazetted_officer: "श्री एबीसी, सुपुत्र श्री एक्सवाईजेड, ने गाँव, परिवार और समुदाय का नाम रोशन किया है। आप यहाँ अपनी उपलब्धियों को 90 शब्दों तक प्रदर्शित कर सकते हैं।",
    desc_army_officer: "श्री डीईएफ, सुपुत्र श्री यूवीडब्ल्यू, गर्व के साथ देश की सेवा करते हैं। उनके समर्पण और वीरता ने हमारे गाँव के युवाओं को देश सेवा के लिए प्रेरित किया है।",
    desc_politician: "श्री जीएचआई, सुपुत्र श्री आरएसटी, एक समर्पित जन सेवक हैं जिन्होंने हमारे निर्वाचन क्षेत्र के विकास और लोगों के कल्याण के लिए अथक प्रयास किया है।",

    // Profiles - Eminent
    desig_group_b_officer: "ग्रुप बी अधिकारी",
    desig_professor: "प्रोफेसर",
    desig_cdlu: "सीडी एलयू सिरसा",
    desig_dsp: "डीएसपी पुलिस सेवा",
    desc_group_b_officer: "ग्रुप बी राजपत्रित अधिकारी के रूप में कार्यरत, कुशल लोक प्रशासन और सरकारी विकास पहलों को लागू करने के लिए समर्पित।",
    desc_professor: "उच्च शिक्षा, अनुसंधान उत्कृष्टता और छात्रों को उज्ज्वल भविष्य के लिए मार्गदर्शन देने में योगदान देने वाले एक प्रतिष्ठित शिक्षाविद्।",
    desc_cdlu: "चौधरी देवी लाल विश्वविद्यालय, सिरसा से जुड़े, शैक्षिक उन्नति और क्षेत्रीय शैक्षणिक विकास की दिशा में कार्यरत।",
    desc_dsp: "पुलिस उपाधीक्षक के रूप में सेवारत, कानून और व्यवस्था बनाए रखने, सार्वजनिक सुरक्षा सुनिश्चित करने और न्याय को बनाए रखने के लिए प्रतिबद्ध।",

    // Profiles - Respected
    desig_teacher: "अध्यापक",
    desig_social_worker: "समाज सेवक",
    desig_police_inspector: "पुलिस इंस्पेक्टर",
    desig_sports_coach: "खेल कोच",
    desig_numberdar: "नंबरदार",
    desc_teacher: "शिक्षा और मार्गदर्शन के माध्यम से गाँव के भविष्य को आकार देने के लिए समर्पित।",
    desc_social_worker: "सामुदायिक सेवा, स्वच्छता और सामाजिक कल्याण पहलों के लिए प्रतिबद्ध।",
    desc_police_inspector: "समर्पण और ईमानदारी के साथ कानून व्यवस्था और नागरिकों की सुरक्षा सुनिश्चित करना।",
    desc_sports_coach: "युवाओं को खेलों में प्रशिक्षित करना, समुदाय में फिटनेस और अनुशासन को बढ़ावा देना।",
    desc_numberdar: "राजस्व मामलों और ग्राम प्रशासन में सहायता करने वाले एक सम्मानित सामुदायिक नेता।",

    // Common Profile
    profile_so: "सुपुत्र",
    profile_sample: "प्रोफ़ाइल नमूना",

    // UI Interaction
    read_more: "और पढ़ें",
    read_less: "कम पढ़ें",
    login_required_like: "कृपया पहले लॉग इन करें, फिर आपकी पसंद को गिना जाएगा।",
    already_liked: "आप पहले ही इस प्रोफ़ाइल को पसंद कर चुके हैं",
    like_failed: "प्रोफ़ाइल पसंद करने में विफल",
    liked_success: "लाइक किया गया!",
    login_required_share: "कृपया साझा करने के लिए पहले लॉग इन करें।",
    share_failed: "साझा करने में विफल",
    shared_success: "साझा किया गया!",
    already_shared: "आप पहले ही इसे साझा कर चुके हैं",
    link_copied: "लिंक क्लिपबोर्ड पर कॉपी किया गया!",
    copy_failed: "लिंक कॉपी करने में विफल",
    cookie_consent_title: "हम कुकी का उपयोग करते हैं",
    cookie_consent_body: "हम साइट चलाने, प्राथमिकताएँ याद रखने और प्रदर्शन सुधारने हेतु कुकी का उपयोग करते हैं। आप सभी स्वीकार कर सकते हैं, गैर-आवश्यक अस्वीकार कर सकते हैं या सेटिंग प्रबंधित कर सकते हैं।",
    cookie_consent_accept: "सभी स्वीकार करें",
    cookie_consent_reject: "गैर-आवश्यक अस्वीकार करें",
    cookie_consent_manage: "प्रबंधित करें",
    cookie_consent_manage_title: "कुकी सेटिंग",
    cookie_consent_save: "पसंद सहेजें",
    cookie_consent_close: "बंद करें",
    cookie_cat_necessary: "अनिवार्य",
    cookie_cat_necessary_desc: "मूल कार्यक्षमता और सुरक्षा हेतु आवश्यक।",
    cookie_cat_preferences: "प्राथमिकताएँ",
    cookie_cat_preferences_desc: "भाषा और UI विकल्प याद रखें।",
    cookie_cat_analytics: "विश्लेषण",
    cookie_cat_analytics_desc: "उपयोग समझने और प्रदर्शन सुधारने में मदद।",
    cookie_cat_marketing: "मार्केटिंग",
    cookie_cat_marketing_desc: "सामग्री मापने/वैयक्तिक बनाने हेतु (यदि सक्षम हो)।",
    citizen_services_title: "नागरिक डिजिटल सेवा पोर्टल",
    citizen_services_subtitle: "केंद्र एवं राज्य सरकार की प्रमाणित डिजिटल सेवाओं हेतु एकीकृत मंच",
    // Service Buttons
    btn_farmer: "किसान सेवाएँ",
    btn_academics: "शिक्षा और नौकरियां",
    btn_certificates: "नागरिक प्रमाण पत्र",
    btn_grievances: "जन शिकायत",
    btn_travel: "यात्रा सेवाएँ",
    personal_dashboard: "व्यक्तिगत डैशबोर्ड",
    // User Profile
    complete_profile_msg: "पहले अपनी प्रोफ़ाइल पूरी करें",
    login_prompt_msg: "सभी सेवाओं का उपयोग करने के लिए अपनी प्रोफ़ाइल बनाएं।",
    yes: "हाँ",
    no: "नहीं",
    save: "सहेजें",
    cancel: "रद्द करें",
    full_name: "पूरा नाम",
    mobile_number: "मोबाइल नंबर",
    email_label: "ईमेल",
    address_label: "पता",
    profile_photo: "प्रोफ़ाइल फोटो",
    change_profile_photo: "प्रोफ़ाइल फोटो बदलें",
    save_profile: "प्रोफ़ाइल सहेजें",
    profile_preferences_title: "प्राथमिकताएँ",
    theme_label: "थीम",
    theme_light: "लाइट",
    theme_dark: "डार्क",
    theme_system: "सिस्टम",
    font_size_label: "फ़ॉन्ट आकार",
    font_default: "डिफ़ॉल्ट",
    font_large: "बड़ा",
    font_xlarge: "बहुत बड़ा",
    panchayati_raj_title: "पंचायती राज",
    pr_member_question: "क्या आप पंचायती राज के सदस्य हैं?",
    pr_designation_label: "पद",
    select_designation: "पद चुनें",
    designation_chairperson: "अध्यक्ष",
    designation_vice_chairperson: "उपाध्यक्ष",
    designation_sarpanch: "सरपंच",
    designation_ward_member: "वार्ड सदस्य",
    pr_institution_label: "संस्था विवरण",
    pr_verification_title: "पंचायती राज सत्यापन",
    pr_member_question2: "क्या आप पंचायती राज सदस्य हैं?",
    pr_status_pending: "सत्यापन लंबित",
    pr_status_verified: "सत्यापित सदस्य",
    pr_status_rejected: "अस्वीकृत",
    pr_designation_label2: "पद",
    pr_designation_sarpanch: "सरपंच",
    pr_designation_panch: "पंच",
    pr_designation_block_samiti_member: "ब्लॉक समिति सदस्य",
    pr_designation_zila_parishad_member: "ज़िला परिषद सदस्य",
    pr_designation_chairman: "अध्यक्ष",
    pr_designation_vice_chairman: "उपाध्यक्ष",
    pr_designation_secretary: "सचिव",
    pr_designation_bdpo: "बीडीपीओ",
    pr_institution_type_label: "संस्था प्रकार",
    select_institution_type: "संस्था प्रकार चुनें",
    institution_type_gp: "ग्राम पंचायत",
    institution_type_bs: "ब्लॉक समिति",
    institution_type_zp: "ज़िला परिषद",
    pr_institution_name_label: "संस्था नाम",
    profile_prompt: "पूर्ण डैशबोर्ड सुविधाओं का उपयोग करने के लिए कृपया अपनी प्रोफ़ाइल पूरी करें",
    namaste: "नमस्ते",
    my_services: "मेरी सेवाएँ",
    add_service: "सेवा जोड़ें",
    my_documents: "मेरे दस्तावेज़",
    add_document: "दस्तावेज़ जोड़ें",
    edit_profile: "प्रोफ़ाइल संपादित करें",
    direct_login: "लॉगिन",
    // Quick Panels
    view_all_services: "सभी सेवाएँ देखें",
    upload_new_document: "नया दस्तावेज़ अपलोड करें",
    sync_whatsapp: "व्हाट्सएप सिंक करें",
    clear_all: "सभी हटाएँ",
    no_services_found: "कोई सेवा नहीं मिली।",
    no_documents_uploaded: "कोई दस्तावेज़ अपलोड नहीं किया गया।",
    no_new_notifications: "कोई नई सूचना नहीं।",
    // Farmer Services
    farmer_services_title: "किसान और ग्रामीण सेवाएं",
    farmer_services_subtitle: "योजनाओं, सब्सिडी, भूमि रिकॉर्ड और किसान सलाह सेवाओं तक एक ही स्थान पर पहुँचें",
    service_farmer_id: "किसान आईडी (AgriStack)",
    service_mfmb: "मेरी फसल मेरा ब्यौरा",
    service_land_records: "जमाबंदी / भूमि रिकॉर्ड",
    service_pm_kisan: "पीएम-किसान सम्मान निधि",
    service_crop_advisory: "फसल रोग और मौसम सलाह",
    service_pmfby: "फसल बीमा (PMFBY)",
    service_agri_subsidies: "कृषि सब्सिडी (सक्रिय योजनाएं)",
    service_pm_mandhan: "पीएम-किसान मानधन (पेंशन)",
    service_soil_health: "मृदा स्वास्थ्य कार्ड",
    service_kisan_call: "किसान कॉल सेंटर / सलाह",
    service_agri_infra_fund: "कृषि अवसंरचना कोष",

    // Academic Services
    academic_services_title: "शिक्षा और नौकरियाँ",
    academic_services_desc: "प्रवेश, परीक्षा परिणाम और नौकरी के अवसर आसानी से खोजें।",
    academic_admissions: "प्रवेश (Admissions)",
    academic_results: "परीक्षा परिणाम",
    academic_jobs: "नौकरी रिक्तियां",
    // Certificate Services
    certificate_services_title: "नागरिक प्रमाण पत्र",
    certificate_services_desc: "बिना किसी भ्रम के महत्वपूर्ण प्रमाण पत्रों और नागरिक सेवाओं के लिए आवेदन करें।",
    cert_birth_death: "जन्म और मृत्यु प्रमाण पत्र",
    cert_caste: "जाति प्रमाण पत्र",
    cert_residence: "रिहायशी प्रमाण पत्र",
    cert_income: "आय प्रमाण पत्र",
    cert_family_id: "परिवार पहचान पत्र (PPP)",
    cert_birth: "जन्म प्रमाण पत्र",
    cert_pension: "पेंशन सेवाएं",
    cert_aadhaar: "आधार सेवाएं",
    cert_driving_license: "ड्राइविंग लाइसेंस",
    cert_ration_card: "राशन कार्ड",
    cert_voter_id: "वोटर आईडी",
    cert_character: "चरित्र प्रमाण पत्र",
    cert_unemployment: "बेरोजगारी भत्ता",
    // Navigation
    back_to_menu: "मेनू पर वापस जाएं",
    back_home: "होम पर वापस जाएं",
    home_tooltip: "होम",
    // Online Services Info
    why_use_title: "इस पोर्टल का उपयोग क्यों करें",
    why_use_intro: "**एक सिंगल प्रोफाइल** बनाकर, आपको मिलता है:",
    why_use_point_1: "**एकीकृत पहुंच**: योजनाओं, प्रमाणपत्रों और नौकरियों के लिए एक ही जगह से आवेदन करें।",
    why_use_point_2: "**सुरक्षित भंडारण**: अपने सभी दस्तावेजों को सुरक्षित और सुलभ रखें।",
    why_use_point_3: "**समय पर सूचनाएं**: आवेदन की स्थिति और नई योजनाओं पर अपडेट प्राप्त करें।",
    why_use_footer: "समय बचाएं और कई कार्यालयों के चक्कर लगाने से बचें।",
    disclaimer_portal_title: "अस्वीकरण",
    disclaimer_portal_body: "यह पोर्टल केवल जानकारी और सुविधा के लिए प्रदान किया गया है। आधिकारिक प्रसंस्करण संबंधित विभागों द्वारा किया जाता है।",
    how_to_use_portal_title: "इस पोर्टल का उपयोग कैसे करें",
    how_to_use_step_1: "ऊपर **श्रेणी टैब** पर क्लिक करें (जैसे, किसान, छात्र)।",
    how_to_use_step_2: "**अपनी प्रोफाइल बनाएं** या सुरक्षित रूप से लॉग इन करें।",
    how_to_use_step_3: "उपलब्ध सेवाओं को ब्राउज़ करें और **ऑनलाइन आवेदन करें**।",
    how_to_use_step_4: "आवश्यक दस्तावेज अपलोड करें और सबमिट करें।",
    how_to_use_step_5: "स्थिति ट्रैक करें और डिजिटल रूप से प्रमाण पत्र प्राप्त करें।",
    how_to_use_footer: "मदद चाहिए? शिकायत टैब पर जाएं।",
    disclaimer_label: "अस्वीकरण",
    disclaimer_text: "पीआरआई सदस्यों की तस्वीरें केवल सार्वजनिक जानकारी के उद्देश्य से सहमति के साथ प्रकाशित की गई हैं। यह मंच कोई आधिकारिक सरकारी रिकॉर्ड नहीं है। कोई भी सदस्य किसी भी समय अपनी जानकारी में सुधार या हटाने का अनुरोध कर सकता है।",
  },
  pa: {
    title: "ਮੇਰੀ ਡਿਜੀਟਲ ਪੰਚਾਇਤ : ਮੇਰਾ ਮਾਣ",
    welcome_title: "ਹਰਿਆਣਾ ਦੇ ਡਿਜ਼ਿਟਲ ਪਿੰਡ ਨੈੱਟਵਰਕ ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcome_to_gp: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ",
    welcome_body:
      "ਹਰਿਆਣਾ ਦੀਆਂ 6,222 ਗ੍ਰਾਮ ਪੰਚਾਇਤਾਂ ਦੀ ਜਾਣ-ਪਛਾਣ ਕਰੋ। ਜਾਣਕਾਰੀ, ਯੋਜਨਾਵਾਂ ਅਤੇ ਵਿਕਾਸ ਅੱਪਡੇਟ ਵੇਖੋ, ਅਤੇ ਆਪਣੀ ਪੰਚਾਇਤ ਨਾਲ ਆਨਲਾਈਨ ਜੁੜੋ।",
    select_district: "ਜ਼ਿਲ੍ਹਾ ਚੁਣੋ",
    select_block_first: "ਪਹਿਲਾਂ ਜ਼ਿਲ੍ਹਾ ਚੁਣੋ",
    select_block: "ਖੰਡ ਚੁਣੋ",
    select_village_first: "ਪਹਿਲਾਂ ਖੰਡ ਚੁਣੋ",
    select_village: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਚੁਣੋ",
    select_level: "ਸੰਸਥਾ ਦੀ ਕਿਸਮ ਚੁਣੋ",
    search_gp_label: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਖੋਜੋ",
    search_gp_placeholder: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਖੋਜੋ",
    clear_search: "ਖੋਜ ਸਾਫ਼ ਕਰੋ",
    search_gp_no_matches: "ਕੋਈ ਨਤੀਜਾ ਨਹੀਂ",
    loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    loading_districts: "ਜ਼ਿਲ੍ਹੇ ਲੋਡ ਹੋ ਰਹੇ ਹਨ...",
    no_districts_available: "ਕੋਈ ਜ਼ਿਲ੍ਹਾ ਉਪਲਬਧ ਨਹੀਂ",
    no_blocks_available: "ਕੋਈ ਬਲਾਕ ਉਪਲਬਧ ਨਹੀਂ",
    no_gram_panchayats_available: "ਕੋਈ ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਉਪਲਬਧ ਨਹੀਂ",
    selected_panchayats: "ਚੁਣੇ ਹੋਏ",
    reselect_panchayat: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਮੁੜ ਚੁਣੋ",
    remove_selection: "ਚੋਣ ਹਟਾਓ",
    admin_data_load_failed: "ਪ੍ਰਸ਼ਾਸਕੀ ਡਾਟਾ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    retry: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    go: "ਜਾਓ",
    continue: "ਜਾਰੀ ਰੱਖੋ",
    level_zp: "ਜ਼ਿਲ੍ਹਾ ਪਰਿਸ਼ਦ",
    level_bs: "ਖੰਡ ਸਮਿਤੀ",
    level_gp: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ",
    level_zp_short_line1: "ਜ਼ਿਲ੍ਹਾ",
    level_zp_short_line2: "ਪਰਿਸ਼ਦ",
    level_bs_short_line1: "ਖੰਡ",
    level_bs_short_line2: "ਸਮਿਤੀ",
    level_gp_short_line1: "ਗ੍ਰਾਮ",
    level_gp_short_line2: "ਪੰਚਾਇਤ",
    first_select_institution: "ਪਹਿਲਾਂ ਆਪਣੀ ਸੰਸਥਾ ਚੁਣੋ",
    sign_in_required_title: "ਲੌਗਇਨ ਲਾਜ਼ਮੀ ਹੈ",
    sign_in_required_message: "ਕਿਰਪਾ ਕਰਕੇ ਅੱਗੇ ਵੱਧਣ ਲਈ ਲੌਗਇਨ ਕਰੋ।",
    sign_in_with_google: "ਲੌਗਇਨ",
    news_title: "ਤਾਜ਼ਾ",
    news_tabs_announcements: "ਖ਼ਬਰਾਂ/ਐਲਾਨ",
    ad_title: "ਵਿਗਿਆਪਨ ਸਥਾਨ",
    ad_body:
      "ਇੱਥੇ ਆਪਣਾ ਕਾਰੋਬਾਰ, ਸੇਵਾ ਜਾਂ ਸਥਾਨਕ ਉਤਪਾਦ ਪ੍ਰਚਾਰ ਕਰੋ। ਸੰਪਰਕ ਕਰੋ:",
    dashboard_title: "ਹਰਿਆਣਾ ਰਾਜ ਡੈਸ਼ਬੋਰਡ",
    total_panchayats: "ਕੁੱਲ ਪੰਚਾਇਤਾਂ",
    districts: "ਜ਼ਿਲ੍ਹੇ",
    registered_users: "ਰਜਿਸਟਰਡ ਯੂਜ਼ਰ",
    footer: "© 2025 ਮੇਰੀ ਡਿਜੀਟਲ ਪੰਚਾਇਤ : ਮੇਰਾ ਮਾਣ। ਟੈਕ ਮੈਸਟ੍ਰੋ ਡਿਜ਼ਿਟਲ ਸਰਵਿਸਜ਼ ਦੁਆਰਾ ਵਿਕਸਿਤ।",
    caption_pm: "ਸ਼੍ਰੀ ਨਰਿੰਦਰ ਮੋਦੀ, ਭਾਰਤ ਦੇ ਪ੍ਰਧਾਨ ਮੰਤਰੀ",
    caption_cm: "ਸ਼੍ਰੀ ਨਾਇਬ ਸਿੰਘ ਸੈਣੀ, ਹਰਿਆਣਾ ਦੇ ਮੁੱਖ ਮੰਤਰੀ",
    caption_minister: "ਸ਼੍ਰੀ ਕ੍ਰਿਸ਼ਨ ਲਾਲ ਪੰਵਾਰ, ਹਰਿਆਣਾ ਸਰਕਾਰ ਦੇ ਵਿਕਾਸ ਅਤੇ ਪੰਚਾਇਤੀ ਰਾਜ ਮੰਤਰੀ",
    cm_name: "ਸ਼੍ਰੀ ਨਾਇਬ ਸਿੰਘ ਸੈਣੀ",
    cm_designation: "ਮੁੱਖ ਮੰਤਰੀ, ਹਰਿਆਣਾ ਸਰਕਾਰ",
    pm_name: "ਸ਼੍ਰੀ ਕ੍ਰਿਸ਼ਨ ਲਾਲ ਪੰਵਾਰ",
    pm_designation: "ਵਿਕਾਸ ਅਤੇ ਪੰਚਾਇਤੀ ਰਾਜ ਮੰਤਰੀ",
    panch_ward_label: "ਪੰਚ ਵਾਰਡ ਨੰ.",
    block_samitis: "ਖੰਡ ਸਮਿਤੀਆਂ",
    data_source_label: "ਸਰੋਤ",
    data_source_value: "ਅਧਿਕਾਰਿਕ ਹਰਿਆਣਾ ਪੰਚਾਇਤੀ ਰਾਜ ਪ੍ਰਸ਼ਾਸਨਿਕ ਰਿਕਾਰਡ (2025)",
    level_header_tagline: "ਆਓ ਆਪਣੀ ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਦਾ ਦੌਰਾ ਕਰੀਏ",
    sarpanch_of_village: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ {village} ਦਾ ਸਰਪੰਚ",
    sarpanch_placeholder_aria: "ਸਰਪੰਚ ਪਲੇਸਹੋਲਡਰ",
    sarpanch_title: "ਸਰਪੰਚ",
    panch_ward_prefix: "ਪੰਚ ਵਾਰਡ",
    block_samiti_member_label: "ਬਲਾਕ ਸੰਮਤੀ ਮੈਂਬਰ",
    zila_parishad_member_label: "ਜ਼ਿਲ੍ਹਾ ਪ੍ਰੀਸ਼ਦ ਮੈਂਬਰ",
    previous_gram_panchayat: "ਸਾਬਕਾ ਗ੍ਰਾਮ ਪੰਚਾਇਤ",
    previous_block_samiti: "ਸਾਬਕਾ ਬਲਾਕ ਸੰਮਤੀ",
    previous_zila_parishad: "ਸਾਬਕਾ ਜ਼ਿਲ੍ਹਾ ਪ੍ਰੀਸ਼ਦ",
    correction_link_text: "#ਨਾਮ ਵਿੱਚ ਸੁਧਾਰ ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    correction_message: "ਇਹ ਵੈੱਬ ਪੇਜ ਤਿੰਨ ਡਰਾਪਡਾਉਨ ਸੂਚੀਆਂ ਤੋਂ ਵੇਰਵੇ ਪ੍ਰਾਪਤ ਕਰਦਾ ਹੈ ਅਤੇ ਇਸ ਵਿੱਚ ਸੁਧਾਰ ਦੀ ਲੋੜ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਦੱਸੋ ਕਿ ਤਬਦੀਲੀਆਂ ਕਿੱਥੇ ਕਰਨੀਆਂ ਹਨ।",
    correction_name_update_template: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ {gp}/ਬਲਾਕ {block}/ਜ਼ਿਲ੍ਹਾ {district} ਦੇ ਵੈੱਬਸਾਈਟ ਪੇਜ ਵਿੱਚ ਸੁਝਾਅ ਅਨੁਸਾਰ ਨਾਮ ਅੱਪਡੇਟ ਕਰਨ ਦੀ ਲੋੜ ਹੈ..",
    show_images: "ਤਸਵੀਰਾਂ ਦਿਖਾਓ",
    hide_images: "ਤਸਵੀਰਾਂ ਲੁਕਾਓ",
    data_unavailable: "ਡੇਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    ward_data_unavailable_btn: "ਡਾਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    whatsapp_image_request_template: "ਮੈਂ '{name}', '{designation}', ਗ੍ਰਾਮ ਪੰਚਾਇਤ '{gp}', ਬਲਾਕ '{block}', ਜਿਲਾ '{district}' ਇਸ ਵੈੱਬਸਾਈਟ 'ਤੇ ਆਪਣੀ ਫੋਟੋ ਲਗਾਨਾ ਚਾਹੁੰਦਾ/ਚਾਹੀਦੀ ਹਾਂ। ਕਿਰਪਾ ਕਰਕੇ ਮੈਨੂੰ ਇਸ ਬਾਰੇ ਜਾਣਕਾਰੀ ਦਿਓ।",
    whatsapp_former_prefix: "ਸਾਬਕਾ ",
    whatsapp_name_missing: "ਨਾਮ ਉਪਲਬਧ ਨਹੀਂ",
    whatsapp_location_missing: "ਉਪਲਬਧ ਨਹੀਂ",
    vice_chairperson_title: "ਉਪ-ਚੇਅਰਪਰਸਨ",
    vice_chairperson_zp_line: "ਉਪ-ਚੇਅਰਪਰਸਨ, ਜ਼ਿਲ੍ਹਾ ਪ੍ਰੀਸ਼ਦ, {parishad}",
    vice_chairperson_bs_line: "ਉਪ-ਚੇਅਰਪਰਸਨ, ਬਲਾਕ ਸੰਮਤੀ, {samiti}",
    prev_body_label: "ਪਿਛਲਾ {level}",
    curr_body_label: "ਮੌਜੂਦਾ {level}",
    click_to_display_image: "ਆਪਣੀ ਤਸਵੀਰ ਦਿਖਾਉਣ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    // Quick Links Tabs
    tab_weather_gp: "ਪਿੰਡ ਦਾ ਮੌਸਮ",
    tab_weather_bs: "ਬਲਾਕ ਦਾ ਮੌਸਮ",
    tab_weather_zp: "ਜ਼ਿਲ੍ਹੇ ਦਾ ਮੌਸਮ",
    tab_services: "ਔਨਲਾਈਨ ਸੇਵਾਵਾਂ",
    tab_eminent_gp: "ਪਿੰਡ ਦੇ ਪ੍ਰਮੁੱਖ ਵਿਅਕਤੀ",
    tab_eminent_bs: "ਬਲਾਕ ਦੇ ਪ੍ਰਮੁੱਖ ਵਿਅਕਤੀ",
    tab_eminent_zp: "ਜ਼ਿਲ੍ਹੇ ਦੇ ਪ੍ਰਮੁੱਖ ਵਿਅਕਤੀ",
    honour_board_gp: "ਪਿੰਡ ਡਿਜੀਟਲ ਸਨਮਾਨ ਬੋਰਡ",
    honour_board_bs: "ਬਲਾਕ ਡਿਜੀਟਲ ਸਨਮਾਨ ਬੋਰਡ",
    honour_board_zp: "ਜ਼ਿਲ੍ਹਾ ਡਿਜੀਟਲ ਸਨਮਾਨ ਬੋਰਡ",
    apply_online: "ਆਨਲਾਈਨ ਅਪਲਾਈ ਕਰੋ",
    already_applied: "ਪਹਿਲਾਂ ਹੀ ਅਰਜ਼ੀ ਦਿੱਤੀ ਗਈ",
    apply_now: "ਹੁਣੇ ਅਰਜ਼ੀ ਦਿਓ",
    rules_regulations: "ਨਿਯਮ ਅਤੇ ਵਿਨਿਯਮ",
    tab_community_gp: "ਸੰਵਾਦ",
    tab_community_bs: "ਬਲਾਕ ਭਾਈਚਾਰਾ",
    tab_community_zp: "ਜ਼ਿਲ੍ਹਾ ਭਾਈਚਾਰਾ",
    tab_reels: "ਰੀਲਗ੍ਰਾਮ",
    tab_music: "ਮੇਰਾ ਸੰਗੀਤ",
    tab_village_hub: "ਵਿਲੇਜ ਹੱਬ",
    tab_tour_gp: "ਪਿੰਡ ਦੀ ਸੈਰ",
    tab_tour_bs: "ਬਲਾਕ ਦੀ ਸੈਰ",
    tab_tour_zp: "ਜ਼ਿਲ੍ਹੇ ਦੀ ਸੈਰ",
    tab_voter: "ਵੋਟਰ ਅਤੇ ਚੋਣ",
    footer_services_title: "ਸੇਵਾਵਾਂ",
    footer_policies_title: "ਸਾਡੀਆਂ ਨੀਤੀਆਂ",
    footer_connect_title: "ਸਾਡੇ ਨਾਲ ਜੁੜੋ",
    footer_tagline: "ਡਿਜ਼ੀਟਲ ਸ਼ਾਸਨ ਰਾਹੀਂ ਪਿੰਡਾਂ ਨੂੰ ਸਸ਼ਕਤ ਬਣਾਉਣਾ",
    footer_total_visitors: "ਕੁੱਲ ਵਿਜ਼ਿਟਰ",
    footer_total_views: "ਕੁੱਲ ਵੇਖਿਆ ਗਿਆ",
    footer_institution_views: "ਇਸ ਸੰਸਥਾ ਦੇ ਵਿਊਜ਼",
    footer_policy_privacy: "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
    footer_policy_terms: "ਵਰਤੋਂ ਦੀਆਂ ਸ਼ਰਤਾਂ",
    footer_policy_cookie: "ਕੂਕੀ ਨੀਤੀ",
    footer_policy_gdpr: "GDPR ਨੀਤੀ",
    footer_policy_refund: "ਰਿਫੰਡ ਨੀਤੀ",
    footer_policy_accessibility: "ਪਹੁੰਚਯੋਗਤਾ ਨੀਤੀ",
    footer_policy_data_usage: "ਡਾਟਾ ਵਰਤੋਂ ਨੀਤੀ",
    policy_effective_date: "ਲਾਗੂ ਤਾਰੀਖ",
    policy_last_updated: "ਆਖ਼ਰੀ ਅੱਪਡੇਟ",
    policy_back_home: "ਹੋਮ ਵਾਪਸ ਜਾਓ",
    policy_not_found: "ਨੀਤੀ ਨਹੀਂ ਮਿਲੀ",
    footer_whatsapp: "ਵਾਟਸਐਪ",
    footer_copyright: "© 2026 Digital Panchayat Mission | ਸਭ ਹੱਕ ਰਾਖਵੇਂ",
    footer_powered_by: "Tech Maestro Digital Services ਵੱਲੋਂ ਸੰਚਾਲਿਤ",
    footer_nav_home: "ਹੋਮ",
    footer_nav_weather: "ਮੌਸਮ",
    footer_nav_online_services: "ਔਨਲਾਈਨ ਸੇਵਾਵਾਂ",
    footer_nav_village_hub: "ਵਿਲੇਜ ਹੱਬ",
    footer_nav_village_tour: "ਪਿੰਡ ਦੀ ਸੈਰ",
    footer_nav_samvaad: "ਸੰਵਾਦ",
    footer_nav_my_music: "ਮੇਰਾ ਸੰਗੀਤ",
    footer_nav_reelgram: "ਰੀਲਗ੍ਰਾਮ",
    footer_nav_elections: "ਚੋਣਾਂ",
    // Quick Links Tooltips
    tab_weather_gp_tooltip: "ਪਿੰਡ ਦਾ ਵਿਸਤ੍ਰਿਤ ਮੌਸਮ ਪੂਰਵ ਅਨੁਮਾਨ ਦੇਖੋ",
    tab_weather_bs_tooltip: "ਬਲਾਕ ਦਾ ਵਿਸਤ੍ਰਿਤ ਮੌਸਮ ਪੂਰਵ ਅਨੁਮਾਨ ਦੇਖੋ",
    tab_weather_zp_tooltip: "ਜ਼ਿਲ੍ਹੇ ਦਾ ਵਿਸਤ੍ਰਿਤ ਮੌਸਮ ਪੂਰਵ ਅਨੁਮਾਨ ਦੇਖੋ",
    tab_services_tooltip: "ਆਨਲਾਈਨ ਸਰਕਾਰੀ ਸੇਵਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਕਰੋ",
    tab_eminent_gp_tooltip: "ਪਿੰਡ ਦੇ ਪ੍ਰਮੁੱਖ ਵਿਅਕਤੀਆਂ ਨੂੰ ਦੇਖੋ",
    tab_eminent_bs_tooltip: "ਬਲਾਕ ਦੇ ਪ੍ਰਮੁੱਖ ਵਿਅਕਤੀਆਂ ਨੂੰ ਦੇਖੋ",
    tab_eminent_zp_tooltip: "ਜ਼ਿਲ੍ਹੇ ਦੇ ਪ੍ਰਮੁੱਖ ਵਿਅਕਤੀਆਂ ਨੂੰ ਦੇਖੋ",
    tab_community_gp_tooltip: "ਸੰਵਾਦ ਨਾਲ ਜੁੜੋ",
    tab_community_bs_tooltip: "ਬਲਾਕ ਦੇ ਭਾਈਚਾਰੇ ਨਾਲ ਜੁੜੋ",
    tab_community_zp_tooltip: "ਜ਼ਿਲ੍ਹੇ ਦੇ ਭਾਈਚਾਰੇ ਨਾਲ ਜੁੜੋ",
    tab_reels_tooltip: "ਸਥਾਨਕ ਛੋਟੇ ਵੀਡੀਓ ਦੇਖੋ",
    tab_music_tooltip: "ਸਥਾਨਕ ਸੰਗੀਤ ਸੁਣੋ",
    tab_village_hub_tooltip: "ਵਿਲੇਜ ਹੱਬ ਅਤੇ ਇਸ ਨਾਲ ਜੁੜੀ ਮੁੱਖ ਜਾਣਕਾਰੀ ਵੇਖੋ",
    vf_village_hub: "ਵਿਲੇਜ ਹੱਬ",
    vf_nav_hub: "ਪਿੰਡ ਦੀ ਸਥ",
    vf_nav_notice: "ਪੰਚਾਇਤ ਨੋਟਿਸ",
    vf_nav_need: "ਸੇਵਾ ਲੋੜ",
    vf_notifications_soon: "ਸੂਚਨਾਵਾਂ ਜਲਦੀ ਆ ਰਹੀਆਂ ਹਨ",
    vf_create_post: "ਪੋਸਟ ਬਣਾਓ",
    vf_choose_category: "ਸ਼੍ਰੇਣੀ ਚੁਣੋ",
    vh_choose_category: "ਪੋਸਟ ਸ਼੍ਰੇਣੀ ਚੁਣੋ",
    vh_choose_option: "ਪੋਸਟ ਕਿਵੇਂ ਬਣਾਉਣੀ ਹੈ",
    vh_option_upload: "ਅਪਲੋਡ",
    vh_option_upload_desc: "ਆਪਣੇ ਡਿਵਾਈਸ ਤੋਂ ਫੋਟੋ, ਵੀਡੀਓ ਜਾਂ ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਕਰੋ।",
    vh_option_fresh: "ਨਵੀਂ ਪੋਸਟ ਬਣਾਓ",
    vh_option_fresh_desc: "ਕੈਪਸ਼ਨ ਲਿਖੋ, ਹੈਸ਼ਟੈਗ ਜੋੜੋ, ਲੋਕੇਸ਼ਨ ਟੈਗ ਕਰੋ, ਮੀਡੀਆ ਐਡਿਟ ਕਰੋ ਅਤੇ ਸ਼ੈਡਿਊਲ ਕਰੋ।",
    vh_option_live: "ਲਾਈਵ ਸਟ੍ਰੀਮ",
    vh_option_live_desc: "ਕੈਮਰੇ ਨਾਲ ਲਾਈਵ-ਸਟਾਈਲ ਰਿਕਾਰਡਿੰਗ ਕਰੋ, ਸਿਰਲੇਖ ਅਤੇ ਪਰਦੇਦਾਰੀ ਸੈੱਟ ਕਰੋ।",
    vh_add_media: "ਮੀਡੀਆ ਜੋੜੋ",
    vh_pick_files: "ਫਾਈਲਾਂ ਚੁਣੋ",
    vh_media_too_large: "ਇੱਕ ਜਾਂ ਵੱਧ ਫਾਈਲਾਂ ਬਹੁਤ ਵੱਡੀਆਂ ਹਨ।",
    vh_camera_denied: "ਕੈਮਰਾ ਅਨੁਮਤੀ ਨਹੀਂ ਮਿਲੀ ਜਾਂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
    vh_live_not_supported: "ਇਸ ਡਿਵਾਈਸ 'ਤੇ ਲਾਈਵ ਰਿਕਾਰਡਿੰਗ ਸਹਾਇਕ ਨਹੀਂ ਹੈ।",
    vh_location_tag: "ਲੋਕੇਸ਼ਨ ਟੈਗ (ਵਿਕਲਪਿਕ)",
    vh_location_placeholder: "ਥਾਂ/ਲੈਂਡਮਾਰ্ক ਲਿਖੋ",
    vh_scheduling: "ਸ਼ੈਡਿਊਲ (ਵਿਕਲਪਿਕ)",
    vh_scheduling_note: "ਜੇ ਤੁਹਾਡੇ ਬੈਕਐਂਡ ਵਿੱਚ ਸ਼ੈਡਿਊਲਿੰਗ ਸਹਾਇਕ ਨਹੀਂ ਹੈ, ਤਾਂ ਪੋਸਟ ਤੁਰੰਤ ਪ੍ਰਕਾਸ਼ਿਤ ਹੋਵੇਗੀ।",
    vh_media_edit: "ਮੀਡੀਆ ਐਡਿਟਿੰਗ",
    vh_crop: "ਕ੍ਰੌਪ",
    vh_filter: "ਫਿਲਟਰ",
    vh_filter_none: "ਕੋਈ ਨਹੀਂ",
    vh_filter_warm: "ਵਾਰਮ",
    vh_filter_mono: "ਮੋਨੋ",
    vh_filter_vivid: "ਵਿਵਿਡ",
    vh_live_setup: "ਲਾਈਵ ਸੈੱਟਅੱਪ",
    vh_live_title: "ਲਾਈਵ ਸਿਰਲੇਖ",
    vh_live_description: "ਵੇਰਵਾ",
    vh_privacy_public: "ਸਾਰਵਜਨਿਕ",
    vh_privacy_village: "ਪਿੰਡ",
    vh_privacy_private: "ਨਿੱਜੀ",
    vh_camera_start: "ਕੈਮਰਾ ਸ਼ੁਰੂ ਕਰੋ",
    vh_camera_stop: "ਕੈਮਰਾ ਬੰਦ ਕਰੋ",
    vh_live_start: "ਰਿਕਾਰਡਿੰਗ ਸ਼ੁਰੂ",
    vh_live_stop: "ਰਿਕਾਰਡਿੰਗ ਰੋਕੋ",
    vh_fmt_bold: "ਬੋਲਡ",
    vh_fmt_italic: "ਇਟੈਲਿਕ",
    vh_fmt_underline: "ਅੰਡਰਲਾਈਨ",
    vh_err_permission: "ਤੁਹਾਨੂੰ ਪੋਸਟ ਕਰਨ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਹੈ।",
    vh_err_network: "ਨੈੱਟਵਰਕ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    vh_err_sign_in: "ਪੋਸਟ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ।",
    vh_err_unknown: "ਪੋਸਟ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    vh_err_category_required: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਸ਼੍ਰੇਣੀ ਚੁਣੋ।",
    vh_err_bucket_missing: "ਸਟੋਰੇਜ ਬਕੇਟ village-feed-media ਮੌਜੂਦ ਨਹੀਂ ਹੈ।",
    vf_message: "ਸੁਨੇਹਾ",
    vf_whats_happening: "ਅੱਜ ਤੁਹਾਡੇ ਪਿੰਡ ਵਿੱਚ ਕੀ ਹੋ ਰਿਹਾ ਹੈ?",
    vh_sticky_prompt: "ਅੱਜ ਤੁਹਾਡੇ ਪਿੰਡ ਵਿੱਚ ਕੀ ਹੋ ਰਿਹਾ ਹੈ ?",
    vh_post_now: "ਪੋਸਟ ਕਰੋ",
    vh_create_post: "ਪੋਸਟ ਬਣਾਓ",
    vh_language_toggle: "ਭਾਸ਼ਾ",
    vh_language_hi: "हिन्दी",
    vh_language_pa: "ਪੰਜਾਬੀ",
    vh_language_hi_short: "हि",
    vh_language_pa_short: "ਪੰ",
    vh_profile_missing_toast: "ਪਹਿਲਾਂ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਪੂਰੀ ਕਰੋ (ਕੁਝ ਵੇਰਵੇ ਘੱਟ ਹਨ)।",
    vf_post: "ਪੋਸਟ ਕਰੋ",
    vf_posting: "ਪੋਸਟ ਹੋ ਰਹੀ ਹੈ...",
    vf_uploading: "ਅਪਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    vf_posted: "ਪੋਸਟ ਹੋ ਗਈ",
    vf_posted_success: "ਪੋਸਟ ਸਫਲਤਾਪੂਰਵਕ ਹੋ ਗਈ",
    vf_post_failed: "ਪੋਸਟ ਨਹੀਂ ਹੋ ਸਕੀ",
    vf_add_media: "ਫੋਟੋ, ਵੀਡੀਓ ਜਾਂ ਆਵਾਜ਼ ਜੋੜੋ",
    vf_text: "ਟੈਕਸਟ",
    vf_photo: "ਫੋਟੋ",
    vf_video: "ਵੀਡੀਓ",
    vf_audio: "ਆਵਾਜ਼",
    vf_stop: "ਰੋਕੋ",
    vf_remove_audio: "ਆਵਾਜ਼ ਹਟਾਓ",
    vf_optional: "ਵਿਕਲਪਿਕ",
    vf_tags: "ਟੈਗ",
    vf_add_tags: "ਟੈਗ ਜੋੜੋ (ਵਿਕਲਪਿਕ)",
    vf_buy_sell_details: "ਖਰੀਦ/ਵਿਕਰੀ ਵੇਰਵਾ",
    vf_item_name: "ਸਾਮਾਨ ਦਾ ਨਾਮ",
    vf_item_required: "ਸਾਮਾਨ ਦਾ ਨਾਮ ਲਾਜ਼ਮੀ ਹੈ",
    vf_item: "ਸਾਮਾਨ",
    vf_price: "ਕੀਮਤ",
    vf_price_unknown: "ਕੀਮਤ ਨਹੀਂ ਦਿੱਤੀ",
    vf_negotiable: "ਗੱਲਬਾਤ ਯੋਗ",
    vf_emergency: "ਐਮਰਜੈਂਸੀ",
    vf_emergency_details: "ਐਮਰਜੈਂਸੀ ਵੇਰਵਾ",
    vf_urgency: "ਤੁਰੰਤਤਾ",
    vf_urgency_high: "ਉੱਚ",
    vf_urgency_medium: "ਮਧ्यम",
    vf_urgency_low: "ਘੱਟ",
    vf_sell_item: "ਸਾਮਾਨ ਵੇਚੋ",
    vf_need_help: "ਮਦਦ ਚਾਹੀਦੀ",
    vf_agri_update: "ਖੇਤੀ",
    vf_login_prompt_title: "ਆਪਣੇ ਪਿੰਡ ਦੇ ਫੀਡ ਨਾਲ ਜੁੜੋ",
    vf_login_prompt_text: "ਪੋਸਟ, ਲਾਇਕ ਅਤੇ ਸੇਵ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ।",
    vf_login_to_interact: "ਇੰਟਰੈਕਟ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ",
    vf_filter_all: "ਸਭ",
    vf_filter_agriculture: "ਖੇਤੀ",
    vf_filter_buy_sell: "ਖਰੀਦ/ਵਿਕਰੀ",
    vf_filter_emergency: "ਐਮਰਜੈਂਸੀ",
    vf_filter_events: "ਕਾਰਜਕ੍ਰਮ",
    vf_filter_education: "ਸਿੱਖਿਆ",
    vf_filter_labour: "ਮਜ਼ਦੂਰੀ",
    vf_load_failed: "ਫੀਡ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ",
    vf_load_failed_hint: "ਜੇ ਪਹਿਲੀ ਵਾਰ ਹੈ, ਤਾਂ Village Feed ਦੀਆਂ ਟੇਬਲਾਂ ਹਾਲੇ ਨਹੀਂ ਬਣੀਆਂ ਹੋ ਸਕਦੀਆਂ।",
    vf_empty_title: "ਹਾਲੇ ਕੋਈ ਪੋਸਟ ਨਹੀਂ",
    vf_empty_text: "ਆਪਣੇ ਪਿੰਡ ਦਾ ਪਹਿਲਾ ਅੱਪਡੇਟ ਸਾਂਝਾ ਕਰੋ।",
    vf_first_post_title: "ਆਪਣੀ ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਵਿੱਚ ਸਭ ਤੋਂ ਪਹਿਲਾਂ ਪੋਸਟ ਕਰੋ।",
    vf_first_post_text: "ਇੱਕ ਸਥਾਨਕ ਅੱਪਡੇਟ ਸ਼ੁਰੂ ਕਰੋ ਤਾਂ ਜੋ ਤੁਹਾਡੀ ਪੰਚਾਇਤ ਜੁੜੀ ਰਹੇ।",
    vf_empty_cta_1: "ਪਹਿਲਾ ਅੱਪਡੇਟ ਪੋਸਟ ਕਰੋ",
    vf_empty_cta_2: "ਖੇਤੀ ਅੱਪਡੇਟ ਪੋਸਟ ਕਰੋ",
    vf_empty_cta_3: "ਸਥਾਨਕ ਤੌਰ ਤੇ ਵੇਚੋ",
    vf_end: "ਤੁਸੀਂ ਸਭ ਦੇਖ ਲਿਆ",
    vf_scope_all: "ਸਭ",
    vf_scope_gp: "ਮੇਰੀ ਪੰਚਾਇਤ",
    vf_scope_nearby: "ਨਜ਼ਦੀਕ",
    vf_scope_block: "ਬਲਾਕ",
    vf_scope_district: "ਜ਼ਿਲ੍ਹਾ",
    vf_scope_state: "ਰਾਜ",
    vf_follow: "ਫਾਲੋ",
    vf_following: "ਫਾਲੋਇੰਗ",
    vh_filter_all: "ਸਭ",
    vh_filter_my_panchayat: "ਮੇਰੀ ਪੰਚਾਇਤ",
    vh_filter_nearby: "ਨੇੜੇ",
    vh_filter_block: "ਬਲਾਕ",
    vh_filter_district: "ਜ਼ਿਲ੍ਹਾ",
    vh_filter_state: "ਰਾਜ",
    vh_filter_haryana: "ਹਰਿਆਣਾ",
    vh_nearby_loading: "ਨੇੜਲੀਆਂ Village Hub ਪੋਸਟਾਂ ਲੋਡ ਹੋ ਰਹੀਆਂ ਹਨ...",
    vh_nearby_permission_required: "ਨੇੜਲੀਆਂ Village Hub ਪੋਸਟਾਂ ਵੇਖਣ ਲਈ ਲੋਕੇਸ਼ਨ ਇਜਾਜ਼ਤ ਲਾਜ਼ਮੀ ਹੈ।",
    vh_nearby_location_unavailable: "ਤੁਹਾਡੀ ਮੌਜੂਦਾ ਲੋਕੇਸ਼ਨ ਨਹੀਂ ਮਿਲ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    vh_nearby_no_posts: "10 ਕਿਮੀ ਦੇ ਅੰਦਰ ਕੋਈ Village Hub ਪੋਸਟ ਨਹੀਂ ਮਿਲੀ।",
    vf_villager: "ਪਿੰਡਵਾਸੀ",
    vf_now: "ਹੁਣੇ",
    vf_time_m: "ਮਿੰ",
    vf_time_h: "ਘੰ",
    vf_time_d: "ਦਿ",
    vf_post_aria: "ਪਿੰਡ ਪੋਸਟ",
    vf_action_failed: "ਕਾਰਵਾਈ ਅਸਫਲ",
    vf_share: "ਸ਼ੇਅਰ",
    vf_share_whatsapp: "ਵਾਟਸਐਪ",
    vf_share_facebook: "ਫੇਸਬੁੱਕ",
    vf_share_native: "ਸ਼ੇਅਰ ਕਰੋ",
    vf_share_instagram: "ਇੰਸਟਾਗ੍ਰਾਮ",
    vf_comments: "ਟਿੱਪਣੀਆਂ",
    vf_share_title: "ਵਿਲੇਜ ਫੀਡ",
    vf_native_share: "ਸ਼ੇਅਰ",
    vf_copy_link: "ਲਿੰਕ ਕਾਪੀ ਕਰੋ",
    vf_post_image: "ਪੋਸਟ ਚਿੱਤਰ",
    vf_open_document: "ਦਸਤਾਵੇਜ਼ ਖੋਲ੍ਹੋ",
    vf_verified: "ਸੱਚਿਆਇਆ",
    vf_post_time: "ਪੋਸਟ ਸਮਾਂ",
    vf_categories_loading: "ਸ਼੍ਰੇਣੀਆਂ ਲੋਡ ਹੋ ਰਹੀਆਂ ਹਨ...",
    vf_categories_load_failed: "ਸ਼੍ਰੇਣੀਆਂ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀਆਂ",
    vf_categories_load_empty: "ਸ਼੍ਰੇਣੀਆਂ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀਆਂ (0)। ਇਹ ਅਕਸਰ ਸੁਰੱਖਿਆ ਨੀਤੀ ਕਾਰਨ ਹੁੰਦਾ ਹੈ।",
    vf_audio_not_supported: "ਇਸ ਡਿਵਾਈਸ ਤੇ ਆਵਾਜ਼ ਰਿਕਾਰਡ ਨਹੀਂ ਹੋ ਰਹੀ।",
    vf_section_your_gp: "ਤੁਹਾਡੀ ਗ੍ਰਾਮ ਪੰਚਾਇਤ",
    vf_section_selected_gp: "ਚੁਣੀ ਹੋਈ ਗ੍ਰਾਮ ਪੰਚਾਇਤ",
    vf_section_nearby_gp: "ਨਜ਼ਦੀਕੀ ਗ੍ਰਾਮ ਪੰਚਾਇਤਾਂ",
    vf_section_your_block: "ਤੁਹਾਡਾ ਬਲਾਕ",
    vf_section_your_district: "ਤੁਹਾਡਾ ਜ਼ਿਲ੍ਹਾ",
    vf_section_across_haryana: "ਹਰਿਆਣਾ ਭਰ ਵਿੱਚ",
    vf_coming_soon: "ਇਹ ਸੈਕਸ਼ਨ ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ।",
    vf_category_general: "ਸਧਾਰਨ",
    vf_category_buy_sell: "ਖਰੀਦ/ਵਿਕਰੀ",
    vf_category_agriculture: "ਖੇਤੀ",
    vf_category_emergency: "ਐਮਰਜੈਂਸੀ",
    vf_category_event: "ਕਾਰਜਕ੍ਰਮ",
    vf_category_events: "ਕਾਰਜਕ੍ਰਮ",
    vf_category_labour: "ਮਜ਼ਦੂਰੀ",
    vf_category_missing: "ਗੁੰਮ",
    vf_category_medical: "ਮੈਡੀਕਲ ਮਦਦ",
    vf_category_education: "ਸਿੱਖਿਆ",
    vf_category_transport: "ਆਵਾਜਾਈ",
    vf_category_news: "ਖ਼ਬਰਾਂ",
    vf_category_entertainment: "ਮਨੋਰੰਜਨ",
    vf_category_sale_purchase: "ਖਰੀਦ/ਵਿਕਰੀ",
    vf_category_advertisement: "ਵਿਗਿਆਪਨ",
    vf_category_others: "ਹੋਰ",
    vh_profile_required_title: "ਪੋਸਟ ਬਣਾਉਣ ਲਈ ਪ੍ਰੋਫ਼ਾਈਲ ਪੂਰੀ ਕਰੋ",
    vh_profile_required_desc: "ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਲੋੜੀਂਦੇ ਵੇਰਵੇ ਭਰੋ, ਫਿਰ ਦੁਬਾਰਾ ਪੋਸਟ ਬਣਾਓ।",
    vh_missing_full_name: "ਪੂਰਾ ਨਾਮ ਲਾਜ਼ਮੀ",
    vh_missing_gp: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਲਾਜ਼ਮੀ",
    vh_missing_phone_verified: "ਤਸਦੀਕ ਕੀਤਾ ਮੋਬਾਈਲ ਲਾਜ਼ਮੀ",
    vh_missing_unknown: "ਕੁਝ ਵੇਰਵੇ ਘੱਟ ਹਨ",
    vf_onboard_1_title: "ਪਿੰਡ ਦੇ ਅੱਪਡੇਟ ਸਾਂਝੇ ਕਰੋ",
    vf_onboard_1_text: "ਰੋਜ਼ਾਨਾ ਅੱਪਡੇਟ, ਕਾਰਜਕ੍ਰਮ ਅਤੇ ਐਲਾਨ ਪੋਸਟ ਕਰੋ।",
    vf_onboard_2_title: "ਸਥਾਨਕ ਖਰੀਦ/ਵਿਕਰੀ",
    vf_onboard_2_text: "ਨੇੜੇ ਸਾਮਾਨ ਵੇਚੋ ਅਤੇ ਲੋੜੀਂਦੀ ਚੀਜ਼ ਲੱਭੋ।",
    vf_onboard_3_title: "ਤੁਰੰਤ ਮਦਦ ਮਿਲੇ",
    vf_onboard_3_text: "ਐਮਰਜੈਂਸੀ, ਮੈਡੀਕਲ ਮਦਦ ਜਾਂ ਜ਼ਰੂਰੀ ਲੋੜ ਪੋਸਟ ਕਰੋ।",
    vf_onboard_4_title: "ਪੰਚਾਇਤ ਨਾਲ ਜੁੜੋ",
    vf_onboard_4_text: "ਨੋਟਿਸ ਅਤੇ ਮਹੱਤਵਪੂਰਨ ਅੱਪਡੇਟ ਵੇਖੋ।",
    vf_skip: "ਛੱਡੋ",
    vf_back: "ਵਾਪਸ",
    vf_next: "ਅੱਗੇ",
    vf_start: "ਸ਼ੁਰੂ ਕਰੋ",
    vf_comments_title: "ਟਿੱਪਣੀਆਂ",
    vf_comment_placeholder: "ਟਿੱਪਣੀ ਲਿਖੋ...",
    vf_send: "ਭੇਜੋ",
    vf_no_comments: "ਹਾਲੇ ਕੋਈ ਟਿੱਪਣੀ ਨਹੀਂ। ਪਹਿਲੀ ਟਿੱਪਣੀ ਕਰੋ।",
    vf_load_more_comments: "ਪੁਰਾਣੀਆਂ ਟਿੱਪਣੀਆਂ ਵੇਖੋ",
    vf_comments_failed: "ਟਿੱਪਣੀਆਂ ਲੋਡ ਨਹੀਂ ਹੋਈਆਂ",
    vf_comment_failed: "ਟਿੱਪਣੀ ਨਹੀਂ ਭੇਜੀ ਜਾ ਸਕੀ",
    vf_login_to_comment: "ਟਿੱਪਣੀ ਲਈ ਲੌਗਇਨ ਕਰੋ",
    tab_tour_gp_tooltip: "ਪਿੰਡ ਦਾ ਵਰਚੁਅਲ ਦੌਰਾ ਕਰੋ",
    tab_tour_bs_tooltip: "ਬਲਾਕ ਦਾ ਵਰਚੁਅਲ ਦੌਰਾ ਕਰੋ",
    tab_tour_zp_tooltip: "ਜ਼ਿਲ੍ਹੇ ਦਾ ਵਰਚੁਅਲ ਦੌਰਾ ਕਰੋ",
    tab_voter_tooltip: "ਵੋਟਰ ਅਤੇ ਚੋਣ ਜਾਣਕਾਰੀ ਦੇਖੋ",
    voter_list_title: "ਵੋਟਰ ਸੂਚੀ",
    voter_list_desc: "ਆਪਣੇ ਇਲਾਕੇ ਦੀ ਨਵੀਨਤਮ ਵੋਟਰ ਸੂਚੀ ਡਾਊਨਲੋਡ ਕਰੋ।",
    download_pdf: "ਪੀਡੀਐਫ ਡਾਊਨਲੋਡ ਕਰੋ",
    election_comm_title: "ਚੋਣ ਕਮਿਸ਼ਨ",
    election_comm_desc: "ਸਰਕਾਰੀ ਚੋਣ ਕਮਿਸ਼ਨ ਪੋਰਟਲ ਤੇ ਜਾਓ।",
    visit_website: "ਵੈੱਬਸਾਈਟ ਤੇ ਜਾਓ",
    important_info: "ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ",
    election_dates_msg: "ਆਉਣ ਵਾਲੀਆਂ ਪੰਚਾਇਤੀ ਚੋਣਾਂ ਦੀਆਂ ਤਰੀਕਾਂ ਦਾ ਐਲਾਨ ਜਲਦੀ ਹੀ ਕੀਤਾ ਜਾਵੇਗਾ। ਕਿਰਪਾ ਕਰਕੇ ਅੱਪਡੇਟ ਲਈ ਨਿਯਮਿਤ ਤੌਰ ਤੇ ਜਾਂਚ ਕਰੋ।",
    reel_label: "ਰੀਲ {index}",
    music_track_label: "ਲੋਕ ਗੀਤ ਟਰੈਕ {index}",
    music_artist_label: "ਸਥਾਨਕ ਕਲਾਕਾਰ",
    tour_site_label: "ਇਤਿਹਾਸਕ ਸਥਾਨ {index}",
    tour_site_desc: "ਦੇਖਣ ਲਈ ਇੱਕ ਸੁੰਦਰ ਸਥਾਨ।",
    image_prompt_l1: "ਆਪਣੀ ਤਸਵੀਰ",
    image_prompt_l2: "ਦਿਖਾਉਣ ਲਈ",
    image_prompt_l3: "ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    // Chairperson caption lines and labels
    chairperson_title: "ਪਰਧਾਨ",
    chairperson_zp_line: "ਪਰਧਾਨ, ਜ਼ਿਲ੍ਹਾ ਪਰਿਸ਼ਦ, {parishad}",
    chairperson_bs_line: "ਪਰਧਾਨ, ਖੰਡ ਸਮਿਤੀ, {samiti}",
    unknown_label: "ਅਣਜਾਣ",
    // Welcome message variants for Gram Panchayat subpage
    dropdown_welcome_msg: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ {village} ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcome_gp_main: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ {village} ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcome_loc_suffix: "({district})",
    welcome_gp_heading: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ {village} ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcome_dynamic_loc: "{village} , {block} , {district} ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcome_bs_heading: "ਖੰਡ ਸਮਿਤੀ {block} ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcome_zp_heading: "ਜ਼ਿਲ੍ਹਾ ਪਰਿਸ਼ਦ {district} ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    institution_gp_heading: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ {village}",
    institution_bs_heading: "ਖੰਡ ਸਮਿਤੀ {block}",
    institution_zp_heading: "ਜ਼ਿਲ੍ਹਾ ਪਰਿਸ਼ਦ {district}",
    gp_location_line: "{district} · {block}",
    latest_updates_title: "ਤਾਜ਼ਾ ਅੱਪਡੇਟ",
    gp_not_found: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਨਹੀਂ ਮਿਲੀ",
    block_not_found: "ਬਲਾਕ ਨਹੀਂ ਮਿਲਿਆ",
    district_shard_not_found: "ਜ਼ਿਲ੍ਹਾ ਡੇਟਾ ਨਹੀਂ ਮਿਲਿਆ",
    failed_to_load_gp_data: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਡੇਟਾ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    error: "ਗਲਤੀ",
    dismiss: "ਖਾਰਜ ਕਰੋ",
    back: "ਵਾਪਸ",
    subtitle_farmer: "ਸਕੀਮਾਂ, ਸਬਸਿਡੀਆਂ, ਜ਼ਮੀਨੀ ਰਿਕਾਰਡ ਅਤੇ ਪੇਂਡੂ ਸੇਵਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਕਰੋ",
    subtitle_academics: "ਦਾਖਲੇ, ਪ੍ਰੀਖਿਆਵਾਂ, ਨਤੀਜੇ ਅਤੇ ਨੌਕਰੀ ਦੇ ਮੌਕੇ ਆਸਾਨੀ ਨਾਲ ਲੱਭੋ।",
    subtitle_certificates: "ਮਹੱਤਵਪੂਰਨ ਸਰਟੀਫਿਕੇਟਾਂ ਅਤੇ ਨਾਗਰਿਕ ਸੇਵਾਵਾਂ ਲਈ ਬਿਨਾਂ ਕਿਸੇ ਉਲਝਣ ਦੇ ਅਪਲਾਈ ਕਰੋ।",
    subtitle_grievances: "ਸ਼ਿਕਾਇਤਾਂ ਦਰਜ ਕਰੋ, ਬੇਨਤੀਆਂ ਨੂੰ ਟਰੈਕ ਕਰੋ ਅਤੇ ਸਹਾਇਤਾ ਪ੍ਰਾਪਤ ਕਰੋ",
    subtitle_travel: "ਯਾਤਰਾ ਬੁੱਕ ਕਰੋ, ਰੂਟ ਚੈੱਕ ਕਰੋ ਅਤੇ ਟ੍ਰਾਂਸਪੋਰਟ ਨਾਲ ਸਬੰਧਤ ਸੇਵਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਕਰੋ।",
    data_load_error: "ਡਾਟਾ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    district_not_found: "ਜ਼ਿਲ੍ਹਾ ਨਹੀਂ ਮਿਲਿਆ।",
    // Weather
    village_weather: "ਪਿੰਡ ਦਾ ਮੌਸਮ",
    weather_feels_like: "ਮਹਿਸੂਸ ਹੋ ਰਿਹਾ ਹੈ",
    weather_now: "ਹੁਣ",
    weather_hourly_forecast: "ਘੰਟਾਵਾਰ ਭਵਿੱਖਬਾਣੀ",
    weather_7_day_forecast: "7-ਦਿਨਾਂ ਦੀ ਭਵਿੱਖਬਾਣੀ",
    weather_forecast_today: "ਅੱਜ",
    weather_forecast_tomorrow: "ਭਲਕੇ",
    weather_alert: "ਮੌਸਮ ਚੇਤਾਵਨੀ",
    weather_alert_rain_desc: "ਮੀਂਹ ਦੀ ਸੰਭਾਵਨਾ ਹੈ। ਜੇ ਲੋੜ ਹੋਵੇ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਫਸਲਾਂ ਦੀ ਸੁਰੱਖਿਆ ਯਕੀਨੀ ਬਣਾਓ।",
    weather_search_placeholder: "ਜ਼ਿਲ੍ਹਾ ਜਾਂ ਬਲਾਕ ਖੋਜੋ...",
    weather_recent: "ਹਾਲ ਹੀ ਵਿੱਚ",
    weather_no_matches: "ਕੋਈ ਨਤੀਜਾ ਨਹੀਂ ਮਿਲਿਆ",
    weather_search_prompt: "ਮੌਸਮ ਦੇਖਣ ਲਈ ਕੋਈ ਸਥਾਨ ਖੋਜੋ।",
    weather_humidity: "ਨਮੀ",
    weather_wind: "ਹਵਾ",
    weather_sunrise: "ਸੂਰਜ ਚੜ੍ਹਨਾ",
    weather_sunset: "ਸੂਰਜ ਡੁੱਬਣਾ",
    weather_select_location: "ਸਥਾਨ ਚੁਣੋ",
    weather_unknown: "ਅਣਜਾਣ",
    weather_clear_sky: "ਸਾਫ਼ ਅਸਮਾਨ",
    weather_partly_cloudy: "ਅੰਸ਼ਕ ਬੱਦਲਵਾਈ",
    weather_foggy: "ਧੁੰਦ",
    weather_rainy: "ਮੀਂਹ",
    weather_snow: "ਬਰਫਬਾਰੀ",
    weather_showers: "ਬੌਛਾਰਾਂ",
    weather_thunderstorm: "ਤੂਫਾਨ",
    // Weather Advanced
    weather_precipitation: "ਵਰਖਾ",
    weather_chance: "ਸੰਭਾਵਨਾ",
    weather_wind_direction: "ਹਵਾ ਦੀ ਦਿਸ਼ਾ",
    weather_disease_risk: "ਰੋਗ ਦਾ ਖਤਰਾ",
    weather_wind_conditions: "ਹਵਾ ਅਤੇ ਹਾਲਾਤ",
    weather_alert_heatwave_warning: "ਗਰਮੀ ਦੀ ਲਹਿਰ ਚੇਤਾਵਨੀ",
    weather_alert_heatwave_warning_msg: "ਹਾਈਡਰੇਟਿਡ ਰਹੋ, ਦੁਪਹਿਰ ਦੀ ਧੁੱਪ ਤੋਂ ਬਚੋ",
    weather_alert_severe_heatwave: "ਗੰਭੀਰ ਗਰਮੀ ਦੀ ਲਹਿਰ",
    weather_alert_severe_heatwave_msg: "ਬਹੁਤ ਗਰਮੀ! ਘਰ ਦੇ ਅੰਦਰ ਰਹੋ।",
    weather_alert_coldwave_warning: "ਠੰਢੀ ਲਹਿਰ ਚੇਤਾਵਨੀ",
    weather_alert_coldwave_warning_msg: "ਠੰਢ ਦਾ ਪ੍ਰਕੋਪ। ਫਸਲਾਂ ਅਤੇ ਪਸ਼ੂਆਂ ਦੀ ਰੱਖਿਆ ਕਰੋ।",
    weather_alert_rain_risk: "ਦਰਮਿਆਨੀ ਬਾਰਸ਼ ਦਾ ਖਤਰਾ",
    weather_alert_rain_risk_msg: "ਖੇਤਾਂ ਤੋਂ ਪਾਣੀ ਦੀ ਨਿਕਾਸੀ ਯਕੀਨੀ ਬਣਾਓ",
    weather_alert_rain_advisory: "ਹਲਕੀ ਬਾਰਸ਼ ਦੀ ਸਲਾਹ",
    weather_alert_rain_advisory_msg: "ਹਲਕੀ ਬਾਰਸ਼ ਸੰਭਵ। ਫਸਲ ਦੀ ਨਮੀ ਦੀ ਨਿਗਰਾਨੀ ਕਰੋ।",
    weather_alert_storm_severe: "ਗੰਭੀਰ ਤੂਫਾਨ ਦੀ ਚੇਤਾਵਨੀ",
    weather_alert_storm_severe_msg: "ਤੇਜ਼ ਹਵਾਵਾਂ ਅਤੇ ਬਿਜਲੀ ਡਿੱਗਣ ਦੀ ਸੰਭਾਵਨਾ। ਸੁਰੱਖਿਅਤ ਥਾਂ 'ਤੇ ਰਹੋ।",
    weather_alert_storm_advisory: "ਹਵਾ ਦੀ ਸਲਾਹ",
    weather_alert_storm_advisory_msg: "ਤੇਜ਼ ਹਵਾਵਾਂ ਦੀ ਸੰਭਾਵਨਾ। ਢਿੱਲੇ ਢਾਂਚਿਆਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰੋ।",
    weather_location_error: "{block}, {district} ਲਈ ਸਥਾਨ ਕੋਆਰਡੀਨੇਟ ਨਹੀਂ ਮਿਲੇ। ਡਿਫੌਲਟ ਵਰਤ ਰਿਹਾ ਹੈ।",
    weather_gis_file_error: "ਸਥਾਨ ਡਾਟਾਬੇਸ ਫਾਈਲ ਗੁੰਮ ਹੈ ਜਾਂ ਖਰਾਬ ਹੋ ਗਈ ਹੈ।",
    weather_gis_district_not_found: "ਸਥਾਨ ਡਾਟਾਬੇਸ ਵਿੱਚ ਜ਼ਿਲ੍ਹਾ ਨਹੀਂ ਮਿਲਿਆ: {district}।",
    weather_gis_filter_invalid: "ਜ਼ਿਲ੍ਹੇ ਲਈ ਸਥਾਨ ਡਾਟਾਬੇਸ ਐਂਟਰੀ ਅਵੈਧ ਹੈ: {district}।",
    weather_gis_invalid_coords: "ਜ਼ਿਲ੍ਹੇ ਲਈ ਅਵੈਧ ਕੋਆਰਡੀਨੇਟ ਮਿਲੇ: {district}।",
    weather_light_showers: "ਹਲਕੀ ਬਾਰਿਸ਼",
    weather_expected: "ਉਮੀਦ ਹੈ",
    weather_gis_error: "{block}, {district} ਲਈ ਸਥਾਨ ਕੋਆਰਡੀਨੇਟ ਨਹੀਂ ਮਿਲੇ। ਡਿਫੌਲਟ ਵਰਤ ਰਿਹਾ ਹੈ।",
    weather_gis_load_error: "ਸਥਾਨ ਡਾਟਾਬੇਸ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
    weather_fetch_error: "ਮੌਸਮ ਡੇਟਾ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    weather_update: "ਮੌਸਮ ਅੱਪਡੇਟ ਕਰੋ",
    weather_fetching: "ਸਥਾਨਕ ਮੌਸਮ ਡੇਟਾ ਪ੍ਰਾਪਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    weather_load_error: "ਮੌਸਮ ਡੇਟਾ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
    weather_change_location: "ਸਥਾਨ ਬਦਲੋ",
    weather_click_change: "ਬਦਲਣ ਲਈ ਕਲਿੱਕ ਕਰੋ",
    weather_low: "ਘੱਟ",
    weather_high: "ਵੱਧ",
    weather_pressure: "ਦਬਾਅ",
    weather_forecast_7day: "7-ਦਿਨਾਂ ਦੀ ਭਵਿੱਖਬਾਣੀ",
    view_less: "ਘੱਟ ਵੇਖੋ",
    view_all: "ਸਭ ਵੇਖੋ",
    weather_precip: "ਵਰਖਾ",
    weather_crop_advisory: "ਫਸਲ ਸਲਾਹ",
    weather_auto_updated: "ਸਵੈ-ਅੱਪਡੇਟ",
    weather_extreme_alert: "ਗੰਭੀਰ ਚੇਤਾਵਨੀ",
    weather_warning: "ਚੇਤਾਵਨੀ",
    weather_select_gp: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਚੁਣੋ",
    // Crops & Advisory
    crop_wheat: "ਕਣਕ",
    crop_rice: "ਝੋਨਾ",
    crop_cotton: "ਨਰਮਾ",
    crop_mustard: "ਸਰ੍ਹੋਂ",
    advisory_favorable: "ਉਗਾਉਣ ਦੇ ਅਨੁਕੂਲ ਹਾਲਾਤ",
    crop_sugarcane: "ਗੰਨਾ",
    disease_rust: "ਪੀਲੀ ਕੁੰਗੀ",
    disease_blight: "ਝੁਲਸ ਰੋਗ",
    disease_pest: "ਕੀੜੇ ਦਾ ਹਮਲਾ",
    advisory_irrigation: "ਲੋੜ ਅਨੁਸਾਰ ਸਿੰਚਾਈ ਕਰੋ।",
    advisory_spray: "ਸਿਫਾਰਸ਼ ਕੀਤੀ ਕੀਟਨਾਸ਼ਕਾਂ ਦਾ ਛਿੜਕਾਅ ਕਰੋ।",
    advisory_harvest: "ਪੱਕੀ ਫਸਲ ਦੀ ਕਟਾਈ ਕਰੋ।",
    risk_high: "ਉੱਚ ਜੋਖਮ",
    risk_moderate: "ਦਰਮਿਆਨਾ ਜੋਖਮ",
    risk_low: "ਘੱਟ ਜੋਖਮ",
    // Weekdays
    weekday_sunday: "ਐਤਵਾਰ",
    weekday_monday: "ਸੋਮਵਾਰ",
    weekday_tuesday: "ਮੰਗਲਵਾਰ",
    weekday_wednesday: "ਬੁੱਧਵਾਰ",
    weekday_thursday: "ਵੀਰਵਾਰ",
    weekday_friday: "ਸ਼ੁੱਕਰਵਾਰ",
    weekday_saturday: "ਸ਼ਨੀਵਾਰ",
    weekday_today: "ਅੱਜ",
    weekday_tomorrow: "ਭਲਕੇ",
    // Wind Directions
    wind_N: "ਉ", wind_NNE: "ਉ-ਉ-ਪੂ", wind_NE: "ਉ-ਪੂ", wind_ENE: "ਪੂ-ਉ-ਪੂ",
    wind_E: "ਪੂ", wind_ESE: "ਪੂ-ਦ-ਪੂ", wind_SE: "ਦ-ਪੂ", wind_SSE: "ਦ-ਦ-ਪੂ",
    wind_S: "ਦ", wind_SSW: "ਦ-ਦ-ਪ", wind_SW: "ਦ-ਪ", wind_WSW: "ਪ-ਦ-ਪ",
    wind_W: "ਪ", wind_WNW: "ਪ-ਉ-ਪ", wind_NW: "ਉ-ਪ", wind_NNW: "ਉ-ਉ-ਪ",

    // Conditions
    weather_cond_sunny: "ਧੁੱਪ",
    weather_cond_cloudy: "ਬੱਦਲਵਾਈ",
    weather_cond_broken_clouds: "ਖਿੰਡੇ ਹੋਏ ਬੱਦਲ",
    weather_cond_overcast: "ਬੱਦਲ ਛਾਏ ਹੋਏ",
    weather_cond_rain: "ਮੀਂਹ",
    weather_cond_storm: "ਤੂਫਾਨ",
    weather_cond_clear_sky: "ਸਾਫ਼ ਅਸਮਾਨ",
    weather_cond_partly_cloudy: "ਅੰਸ਼ਕ ਬੱਦਲਵਾਈ",
    weather_cond_light_rain: "ਹਲਕਾ ਮੀਂਹ",
    weather_cond_moderate_rain: "ਦਰਮਿਆਨਾ ਮੀਂਹ",
    weather_cond_thunderstorm: "ਗਰਜ ਨਾਲ ਤੂਫਾਨ",
    weather_cond_foggy: "ਧੁੰਦ",

    // WMO Codes
    weather_cond_0: "ਸਾਫ਼ ਅਸਮਾਨ",
    weather_cond_1: "ਮੁੱਖ ਤੌਰ 'ਤੇ ਸਾਫ਼",
    weather_cond_2: "ਅੰਸ਼ਕ ਬੱਦਲਵਾਈ",
    weather_cond_3: "ਬੱਦਲ ਛਾਏ ਹੋਏ",
    weather_cond_45: "ਧੁੰਦ",
    weather_cond_48: "ਜਮਾ ਦੇਣ ਵਾਲੀ ਧੁੰਦ",
    weather_cond_51: "ਹਲਕੀ ਬੂੰਦਾਬਾਂਦੀ",
    weather_cond_53: "ਦਰਮਿਆਨੀ ਬੂੰਦਾਬਾਂਦੀ",
    weather_cond_55: "ਭਾਰੀ ਬੂੰਦਾਬਾਂਦੀ",
    weather_cond_56: "ਹਲਕੀ ਜਮਾ ਦੇਣ ਵਾਲੀ ਬੂੰਦਾਬਾਂਦੀ",
    weather_cond_57: "ਭਾਰੀ ਜਮਾ ਦੇਣ ਵਾਲੀ ਬੂੰਦਾਬਾਂਦੀ",
    weather_cond_61: "ਹਲਕੀ ਬਾਰਿਸ਼",
    weather_cond_63: "ਦਰਮਿਆਨੀ ਬਾਰਿਸ਼",
    weather_cond_65: "ਭਾਰੀ ਬਾਰਿਸ਼",
    weather_cond_66: "ਹਲਕੀ ਬਰਫੀਲੀ ਬਾਰਿਸ਼",
    weather_cond_67: "ਭਾਰੀ ਬਰਫੀਲੀ ਬਾਰਿਸ਼",
    weather_cond_71: "ਹਲਕੀ ਬਰਫਬਾਰੀ",
    weather_cond_73: "ਦਰਮਿਆਨੀ ਬਰਫਬਾਰੀ",
    weather_cond_75: "ਭਾਰੀ ਬਰਫਬਾਰੀ",
    weather_cond_77: "ਬਰਫ ਦੇ ਦਾਣੇ",
    weather_cond_80: "ਹਲਕੀ ਬਾਰਿਸ਼ ਦੀਆਂ ਬੌਛਾਰਾਂ",
    weather_cond_81: "ਦਰਮਿਆਨੀ ਬਾਰਿਸ਼ ਦੀਆਂ ਬੌਛਾਰਾਂ",
    weather_cond_82: "ਤੇਜ਼ ਬਾਰਿਸ਼ ਦੀਆਂ ਬੌਛਾਰਾਂ",
    weather_cond_85: "ਹਲਕੀ ਬਰਫਬਾਰੀ ਦੀਆਂ ਬੌਛਾਰਾਂ",
    weather_cond_86: "ਭਾਰੀ ਬਰਫਬਾਰੀ ਦੀਆਂ ਬੌਛਾਰਾਂ",
    weather_cond_95: "ਤੂਫਾਨ",
    weather_cond_96: "ਹਲਕੇ ਗੜਿਆਂ ਨਾਲ ਤੂਫਾਨ",
    weather_cond_99: "ਭਾਰੀ ਗੜਿਆਂ ਨਾਲ ਤੂਫਾਨ",

    // Digital Honour Board - Apply Online
    welcome_dhb_title: "ਡਿਜੀਟਲ ਆਨਰ ਬੋਰਡ ਐਪਲੀਕੇਸ਼ਨ ਪੇਜ 'ਤੇ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਅੱਗੇ ਵਧਣ ਤੋਂ ਪਹਿਲਾਂ ਨਿਯਮਾਂ ਅਤੇ ਕਾਨੂੰਨਾਂ ਨੂੰ ਧਿਆਨ ਨਾਲ ਪੜ੍ਹੋ ਅਤੇ ਸਮਝੋ।",
    rules_ack_label: "ਮੈਂ ਨਿਯਮਾਂ ਅਤੇ ਕਾਨੂੰਨਾਂ ਨੂੰ ਪੜ੍ਹ ਅਤੇ ਸਮਝ ਲਿਆ ਹੈ",
    app_form_title: "ਡਿਜੀਟਲ ਆਨਰ ਬੋਰਡ 'ਤੇ ਪ੍ਰੋਫਾਈਲ ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਨ ਲਈ ਅਰਜ਼ੀ",
    select_gp_village: "ਆਪਣੀ ਗ੍ਰਾਮ ਪੰਚਾਇਤ / ਪਿੰਡ ਚੁਣੋ",
    category_select_label: "ਉੱਘੇ ਨਾਗਰਿਕ ਦੀ ਸ਼੍ਰੇਣੀ ਲਈ ਆਪਣੀ ਪਸੰਦ ਦਾ ਸੁਝਾਅ ਦਿਓ",
    cat_distinguished: "ਵਿਸ਼ੇਸ਼ ਉੱਘੇ ਨਾਗਰਿਕ",
    cat_eminent: "ਉੱਘੇ ਨਾਗਰਿਕ",
    cat_respected: "ਸਤਿਕਾਰਤ ਨਾਗਰਿਕ",
    cat_helper_text: "ਸ਼੍ਰੇਣੀ ਬਾਰੇ ਹੋਰ ਜਾਣਨ ਲਈ ਨਿਯਮ ਅਤੇ ਕਾਨੂੰਨ ਦੇਖੋ",
    page_level_select_label: "ਉਹ ਵੈੱਬ ਪੇਜ ਚੁਣੋ ਜਿੱਥੇ ਤੁਸੀਂ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ",
    level_gp_page: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ ਪੇਜ",
    level_bs_page: "ਬਲਾਕ ਸੰਮਤੀ ਪੇਜ",
    level_zp_page: "ਜ਼ਿਲ੍ਹਾ ਪ੍ਰੀਸ਼ਦ ਪੇਜ",
    level_no_space: "ਵਰਤਮਾਨ ਵਿੱਚ ਚੁਣੇ ਗਏ ਪੱਧਰ 'ਤੇ ਇਸ ਸ਼੍ਰੇਣੀ ਲਈ ਕੋਈ ਥਾਂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
    level_approved_limit: "ਮਨਜ਼ੂਰਸ਼ੁਦਾ: {count} / ਸੀਮਾ: {limit}",
    personal_details_title: "ਨਿੱਜੀ ਵੇਰਵੇ",
    placeholder_proper_name: "ਤੁਹਾਡਾ ਸਹੀ ਨਾਮ ਜੋ ਪ੍ਰਦਰਸ਼ਿਤ ਕੀਤਾ ਜਾਣਾ ਹੈ",
    placeholder_father_name: "ਪਿਤਾ ਦਾ ਨਾਮ (ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਨ ਲਈ)",
    placeholder_designation: "ਅਹੁਦਾ / ਪ੍ਰਾਪਤੀ (ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਨ ਲਈ)",
    mobile_label: "ਸੰਚਾਰ ਲਈ ਤੁਹਾਡਾ ਮੋਬਾਈਲ ਨੰਬਰ (ਤਰਜੀਹੀ ਤੌਰ 'ਤੇ ਵਟਸਐਪ)",
    placeholder_mobile: "10 ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    valid_label: "ਮਾਨਯੋਗ",
    invalid_label: "ਅਮਾਨਯੋਗ",
    image_upload_label: "ਪ੍ਰਦਰਸ਼ਿਤ ਕੀਤੀ ਜਾਣ ਵਾਲੀ ਆਪਣੀ ਤਸਵੀਰ ਅਪਲੋਡ ਕਰੋ",
    image_upload_helper: "ਮਨਜ਼ੂਰਸ਼ੁਦਾ ਫਾਰਮੈਟ: JPG / PNG | ਅਧਿਕਤਮ ਆਕਾਰ: 200 KB",
    profile_desc_label: "ਪ੍ਰਦਰਸ਼ਿਤ ਕੀਤੀ ਜਾਣ ਵਾਲੀ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਭਰੋ",
    word_count_label: "{count}/{limit} ਸ਼ਬਦ",
    select_cat_limit: "ਸ਼ਬਦ ਸੀਮਾ ਦੇਖਣ ਲਈ ਸ਼੍ਰੇਣੀ ਚੁਣੋ",
    placeholder_profile_desc: "ਪ੍ਰੋਫਾਈਲ ਵੇਰਵਾ ਦਰਜ ਕਰੋ",
    processing_fee_label: "ਭੁਗਤਾਨ ਕੀਤੀ ਜਾਣ ਵਾਲੀ ਪ੍ਰੋਸੈਸਿੰਗ ਫੀਸ",
    fee_validity_alert: "ਇਹ ਫੀਸ ਪੰਜ ਸਾਲਾਂ ਦੀ ਮਿਆਦ ਲਈ ਵੈਧ ਰਹੇਗੀ।",
    payment_section_title: "ਭੁਗਤਾਨ ਭਾਗ",
    scan_qr_label: "QR ਕੋਡ ਸਕੈਨ ਕਰੋ",
    pay_via_upi_btn: "UPI ਐਪ ਰਾਹੀਂ ਭੁਗਤਾਨ ਕਰੋ",
    payment_confirm_label: "ਮੈਂ ਆਪਣੇ ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰਦਾ ਹਾਂ",
    btn_save_draft: "ਡਰਾਫਟ ਸੇਵ ਕਰੋ",
    btn_edit_details: "ਵੇਰਵੇ ਸੰਪਾਦਿਤ ਕਰੋ",
    btn_final_submit: "ਅੰਤਿਮ ਸਬਮਿਟ",
    submission_success: "ਅਰਜ਼ੀ ਸਫਲਤਾਪੂਰਵਕ ਸਬਮਿਟ ਕੀਤੀ ਗਈ! ਸਥਿਤੀ: ਸਮੀਖਿਆ ਬਾਕੀ ਹੈ।",
    submission_error: "ਜੇਕਰ ਤੁਹਾਨੂੰ ਭੁਗਤਾਨ ਜਾਂ ਸਬਮਿਸ਼ਨ ਵਿੱਚ ਕੋਈ ਸਮੱਸਿਆ ਆ ਰਹੀ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਕੰਪਨੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    upi_scan_option: "UPI ਸਕੈਨ ਵਿਕਲਪ",
    upi_payment_link: "UPI ਭੁਗਤਾਨ ਲਿੰਕ",

    // Profiles - Distinguished
    desig_gazetted_officer: "ਗਜ਼ਟਿਡ ਅਫਸਰ",
    desig_army_officer: "ਫੌਜੀ ਅਫਸਰ",
    desig_politician: "ਸਿਆਸਤਦਾਨ / ਵਿਧਾਇਕ",
    desc_gazetted_officer: "ਸ਼੍ਰੀ ਏਬੀਸੀ, ਸਪੁੱਤਰ ਸ਼੍ਰੀ ਐਕਸਵਾਈਜ਼ੈਡ, ਨੇ ਪਿੰਡ, ਪਰਿਵਾਰ ਅਤੇ ਭਾਈਚਾਰੇ ਦਾ ਨਾਮ ਰੋਸ਼ਨ ਕੀਤਾ ਹੈ। ਤੁਸੀਂ ਇੱਥੇ ਆਪਣੀਆਂ ਪ੍ਰਾਪਤੀਆਂ ਨੂੰ 90 ਸ਼ਬਦਾਂ ਤੱਕ ਪ੍ਰਦਰਸ਼ਿਤ ਕਰ ਸਕਦੇ ਹੋ।",
    desc_army_officer: "ਸ਼੍ਰੀ ਡੀਈਐਫ, ਸਪੁੱਤਰ ਸ਼੍ਰੀ ਯੂਵੀਡਬਲਯੂ, ਮਾਣ ਨਾਲ ਦੇਸ਼ ਦੀ ਸੇਵਾ ਕਰਦੇ ਹਨ। ਉਨ੍ਹਾਂ ਦੇ ਸਮਰਪਣ ਅਤੇ ਬਹਾਦਰੀ ਨੇ ਸਾਡੇ ਪਿੰਡ ਦੇ ਨੌਜਵਾਨਾਂ ਨੂੰ ਦੇਸ਼ ਸੇਵਾ ਲਈ ਪ੍ਰੇਰਿਤ ਕੀਤਾ ਹੈ।",
    desc_politician: "ਸ਼੍ਰੀ ਜੀਐਚਆਈ, ਸਪੁੱਤਰ ਸ਼੍ਰੀ ਆਰਐਸਟੀ, ਇੱਕ ਸਮਰਪਿਤ ਜਨ ਸੇਵਕ ਹਨ ਜਿਨ੍ਹਾਂ ਨੇ ਸਾਡੇ ਹਲਕੇ ਦੇ ਵਿਕਾਸ ਅਤੇ ਲੋਕਾਂ ਦੀ ਭਲਾਈ ਲਈ ਅਣਥੱਕ ਮਿਹਨਤ ਕੀਤੀ ਹੈ।",

    // Profiles - Eminent
    desig_group_b_officer: "ਗਰੁੱਪ ਬੀ ਅਫਸਰ",
    desig_professor: "ਪ੍ਰੋਫੈਸਰ",
    desig_cdlu: "ਸੀਡੀਐਲਯੂ ਸਿਰਸਾ",
    desig_dsp: "ਡੀਐਸਪੀ ਪੁਲਿਸ ਸੇਵਾਵਾਂ",
    desc_group_b_officer: "ਗਰੁੱਪ ਬੀ ਗਜ਼ਟਿਡ ਅਫਸਰ ਵਜੋਂ ਸੇਵਾ ਨਿਭਾ ਰਹੇ ਹਨ, ਕੁਸ਼ਲ ਲੋਕ ਪ੍ਰਸ਼ਾਸਨ ਅਤੇ ਸਰਕਾਰੀ ਵਿਕਾਸ ਪਹਿਲਕਦਮੀਆਂ ਨੂੰ ਲਾਗੂ ਕਰਨ ਲਈ ਸਮਰਪਿਤ।",
    desc_professor: "ਉੱਚ ਸਿੱਖਿਆ, ਖੋਜ ਉੱਤਮਤਾ ਅਤੇ ਵਿਦਿਆਰਥੀਆਂ ਨੂੰ ਉੱਜਵਲ ਭਵਿੱਖ ਲਈ ਮਾਰਗਦਰਸ਼ਨ ਦੇਣ ਵਿੱਚ ਯੋਗਦਾਨ ਪਾਉਣ ਵਾਲੇ ਇੱਕ ਉੱਘੇ ਸਿੱਖਿਆ ਸ਼ਾਸਤਰੀ।",
    desc_cdlu: "ਚੌਧਰੀ ਦੇਵੀ ਲਾਲ ਯੂਨੀਵਰਸਿਟੀ, ਸਿਰਸਾ ਨਾਲ ਜੁੜੇ, ਵਿਦਿਅਕ ਤਰੱਕੀ ਅਤੇ ਖੇਤਰੀ ਅਕਾਦਮਿਕ ਵਿਕਾਸ ਦੀ ਦਿਸ਼ਾ ਵਿੱਚ ਕਾਰਜਸ਼ੀਲ।",
    desc_dsp: "ਪੁਲਿਸ ਉਪ ਕਪਤਾਨ ਵਜੋਂ ਸੇਵਾ ਨਿਭਾ ਰਹੇ, ਕਾਨੂੰਨ ਅਤੇ ਵਿਵਸਥਾ ਬਣਾਈ ਰੱਖਣ, ਜਨਤਕ ਸੁਰੱਖਿਆ ਯਕੀਨੀ ਬਣਾਉਣ ਅਤੇ ਨਿਆਂ ਨੂੰ ਕਾਇਮ ਰੱਖਣ ਲਈ ਵਚਨਬੱਧ।",

    // Profiles - Respected
    desig_teacher: "ਅਧਿਆਪਕ",
    desig_social_worker: "ਸਮਾਜ ਸੇਵਕ",
    desig_police_inspector: "ਪੁਲਿਸ ਇੰਸਪੈਕਟਰ",
    desig_sports_coach: "ਖੇਡ ਕੋਚ",
    desig_numberdar: "ਨੰਬਰਦਾਰ",
    desc_teacher: "ਸਿੱਖਿਆ ਅਤੇ ਮਾਰਗਦਰਸ਼ਨ ਰਾਹੀਂ ਪਿੰਡ ਦੇ ਭਵਿੱਖ ਨੂੰ ਸੰਵਾਰਨ ਲਈ ਸਮਰਪਿਤ।",
    desc_social_worker: "ਭਾਈਚਾਰਕ ਸੇਵਾ, ਸਫਾਈ ਅਤੇ ਸਮਾਜਿਕ ਭਲਾਈ ਪਹਿਲਕਦਮੀਆਂ ਲਈ ਵਚਨਬੱਧ।",
    desc_police_inspector: "ਸਮਰਪਣ ਅਤੇ ਇਮਾਨਦਾਰੀ ਨਾਲ ਕਾਨੂੰਨ ਵਿਵਸਥਾ ਅਤੇ ਨਾਗਰਿਕਾਂ ਦੀ ਸੁਰੱਖਿਆ ਯਕੀਨੀ ਬਣਾਉਣਾ।",
    desc_sports_coach: "ਨੌਜਵਾਨਾਂ ਨੂੰ ਖੇਡਾਂ ਵਿੱਚ ਸਿਖਲਾਈ ਦੇਣਾ, ਭਾਈਚਾਰੇ ਵਿੱਚ ਤੰਦਰੁਸਤੀ ਅਤੇ ਅਨੁਸ਼ਾਸਨ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਨਾ।",
    desc_numberdar: "ਮਾਲ ਮਾਮਲਿਆਂ ਅਤੇ ਗ੍ਰਾਮ ਪ੍ਰਸ਼ਾਸਨ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰਨ ਵਾਲੇ ਇੱਕ ਸਤਿਕਾਰਤ ਭਾਈਚਾਰਕ ਆਗੂ।",

    // Common Profile
    profile_so: "ਸਪੁੱਤਰ",
    profile_sample: "ਪ੍ਰੋਫਾਈਲ ਨਮੂਨਾ",

    // UI Interaction
    read_more: "ਹੋਰ ਪੜ੍ਹੋ",
    read_less: "ਘੱਟ ਪੜ੍ਹੋ",
    login_required_like: "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਲੌਗਇਨ ਕਰੋ, ਫਿਰ ਤੁਹਾਡੀ ਪਸੰਦ ਗਿਣੀ ਜਾਵੇਗੀ।",
    already_liked: "ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਸ ਪ੍ਰੋਫਾਈਲ ਨੂੰ ਪਸੰਦ ਕਰ ਚੁੱਕੇ ਹੋ",
    like_failed: "ਪ੍ਰੋਫਾਈਲ ਪਸੰਦ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    liked_success: "ਪਸੰਦ ਕੀਤਾ ਗਿਆ!",
    login_required_share: "ਕਿਰਪਾ ਕਰਕੇ ਸਾਂਝਾ ਕਰਨ ਲਈ ਪਹਿਲਾਂ ਲੌਗਇਨ ਕਰੋ।",
    share_failed: "ਸਾਂਝਾ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    shared_success: "ਸਾਂਝਾ ਕੀਤਾ ਗਿਆ!",
    already_shared: "ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਹ ਸਾਂਝਾ ਕਰ ਚੁੱਕੇ ਹੋ",
    link_copied: "ਲਿੰਕ ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕੀਤਾ ਗਿਆ!",
    copy_failed: "ਲਿੰਕ ਕਾਪੀ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    cookie_consent_title: "ਅਸੀਂ ਕੂਕੀ ਵਰਤਦੇ ਹਾਂ",
    cookie_consent_body: "ਅਸੀਂ ਸਾਈਟ ਚਲਾਉਣ, ਪਸੰਦਾਂ ਯਾਦ ਰੱਖਣ ਅਤੇ ਕਾਰਗੁਜ਼ਾਰੀ ਸੁਧਾਰਨ ਲਈ ਕੂਕੀ ਵਰਤਦੇ ਹਾਂ। ਤੁਸੀਂ ਸਭ ਮਨਜ਼ੂਰ ਕਰ ਸਕਦੇ ਹੋ, ਗੈਰ-ਜ਼ਰੂਰੀ ਅਸਵੀਕਾਰ ਕਰ ਸਕਦੇ ਹੋ ਜਾਂ ਸੈਟਿੰਗ ਪ੍ਰਬੰਧਿਤ ਕਰ ਸਕਦੇ ਹੋ।",
    cookie_consent_accept: "ਸਭ ਮਨਜ਼ੂਰ ਕਰੋ",
    cookie_consent_reject: "ਗੈਰ-ਜ਼ਰੂਰੀ ਅਸਵੀਕਾਰ ਕਰੋ",
    cookie_consent_manage: "ਪ੍ਰਬੰਧਿਤ ਕਰੋ",
    cookie_consent_manage_title: "ਕੂਕੀ ਸੈਟਿੰਗ",
    cookie_consent_save: "ਪਸੰਦਾਂ ਸੇਵ ਕਰੋ",
    cookie_consent_close: "ਬੰਦ ਕਰੋ",
    cookie_cat_necessary: "ਜ਼ਰੂਰੀ",
    cookie_cat_necessary_desc: "ਮੂਲ ਕਾਰਜਸ਼ੀਲਤਾ ਅਤੇ ਸੁਰੱਖਿਆ ਲਈ ਲਾਜ਼ਮੀ।",
    cookie_cat_preferences: "ਪਸੰਦਾਂ",
    cookie_cat_preferences_desc: "ਭਾਸ਼ਾ ਅਤੇ UI ਚੋਣਾਂ ਯਾਦ ਰੱਖੋ।",
    cookie_cat_analytics: "ਵਿਸ਼ਲੇਸ਼ਣ",
    cookie_cat_analytics_desc: "ਵਰਤੋਂ ਸਮਝਣ ਅਤੇ ਕਾਰਗੁਜ਼ਾਰੀ ਸੁਧਾਰਨ ਵਿੱਚ ਮਦਦ।",
    cookie_cat_marketing: "ਮਾਰਕੀਟਿੰਗ",
    cookie_cat_marketing_desc: "ਸਮੱਗਰੀ ਮਾਪਣ/ਨਿਜੀਕਰਨ ਲਈ (ਜੇ ਚਾਲੂ ਹੋਵੇ)।",
    cta_nominate_title: "ਪਿੰਡ ਦੇ ਨਾਇਕਾਂ ਦਾ ਸਨਮਾਨ ਕਰੋ",
    cta_nominate_body: "ਕੀ ਤੁਸੀਂ ਕਿਸੇ ਅਜਿਹੇ ਨਾਗਰਿਕ ਨੂੰ ਜਾਣਦੇ ਹੋ ਜਿਸਦਾ ਯੋਗਦਾਨ ਸਨਮਾਨ ਦਾ ਹੱਕਦਾਰ ਹੈ? ਡਿਜੀਟਲ ਸਨਮਾਨ ਬੋਰਡ ਲਈ ਉਨ੍ਹਾਂ ਨੂੰ ਨਾਮਜ਼ਦ ਕਰੋ।",
    cta_nominate_btn: "ਇੱਕ ਨਾਗਰਿਕ ਨੂੰ ਨਾਮਜ਼ਦ ਕਰੋ",

    // Misc Weather
    weather_cancel: "ਰੱਦ ਕਰੋ",
    weather_hpa: "hPa",
    citizen_services_title: "ਨਾਗਰਿਕ ਡਿਜੀਟਲ ਸੇਵਾ ਪੋਰਟਲ",
    citizen_services_subtitle: "ਕੇਂਦਰ ਅਤੇ ਰਾਜ ਸਰਕਾਰ ਦੀਆਂ ਪ੍ਰਮਾਣਿਤ ਡਿਜੀਟਲ ਸੇਵਾਵਾਂ ਲਈ ਏਕੀਕ੍ਰਿਤ ਪਲੇਟਫਾਰਮ",
    // Service Buttons
    btn_farmer: "ਕਿਸਾਨ ਸੇਵਾਵਾਂ",
    btn_academics: "ਵਿੱਦਿਅਕ ਅਤੇ ਨੌਕਰੀਆਂ",
    btn_certificates: "ਨਾਗਰਿਕ ਸਰਟੀਫਿਕੇਟ",
    btn_grievances: "ਜਨਤਕ ਸ਼ਿਕਾਇਤਾਂ",
    btn_travel: "ਯਾਤਰਾ ਸੇਵਾਵਾਂ",
    personal_dashboard: "ਨਿੱਜੀ ਡੈਸ਼ਬੋਰਡ",
    // User Profile
    complete_profile_msg: "ਪਹਿਲਾਂ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਪੂਰੀ ਕਰੋ",
    login_prompt_msg: "ਸਾਰੀਆਂ ਸੇਵਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਲਈ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਬਣਾਓ।",
    yes: "ਹਾਂ",
    no: "ਨਹੀਂ",
    save: "ਸੁਰੱਖਿਅਤ ਕਰੋ",
    cancel: "ਰੱਦ ਕਰੋ",
    full_name: "ਪੂਰਾ ਨਾਮ",
    mobile_number: "ਮੋਬਾਈਲ ਨੰਬਰ",
    email_label: "ਈਮੇਲ",
    address_label: "ਪਤਾ",
    profile_photo: "ਪ੍ਰੋਫਾਈਲ ਫੋਟੋ",
    change_profile_photo: "ਪ੍ਰੋਫਾਈਲ ਫੋਟੋ ਬਦਲੋ",
    save_profile: "ਪ੍ਰੋਫਾਈਲ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    profile_preferences_title: "ਪਸੰਦਾਂ",
    theme_label: "ਥੀਮ",
    theme_light: "ਲਾਈਟ",
    theme_dark: "ਡਾਰਕ",
    theme_system: "ਸਿਸਟਮ",
    font_size_label: "ਫੋਂਟ ਆਕਾਰ",
    font_default: "ਡਿਫੌਲਟ",
    font_large: "ਵੱਡਾ",
    font_xlarge: "ਬਹੁਤ ਵੱਡਾ",
    panchayati_raj_title: "ਪੰਚਾਇਤੀ ਰਾਜ",
    pr_member_question: "ਕੀ ਤੁਸੀਂ ਪੰਚਾਇਤੀ ਰਾਜ ਦੇ ਮੈਂਬਰ ਹੋ?",
    pr_designation_label: "ਪਦ",
    select_designation: "ਪਦ ਚੁਣੋ",
    designation_chairperson: "ਚੇਅਰਪਰਸਨ",
    designation_vice_chairperson: "ਵਾਈਸ-ਚੇਅਰਪਰਸਨ",
    designation_sarpanch: "ਸਰਪੰਚ",
    designation_ward_member: "ਵਾਰਡ ਮੈਂਬਰ",
    pr_institution_label: "ਸੰਸਥਾ ਵੇਰਵਾ",
    pr_verification_title: "ਪੰਚਾਇਤੀ ਰਾਜ ਤਸਦੀਕ",
    pr_member_question2: "ਕੀ ਤੁਸੀਂ ਪੰਚਾਇਤੀ ਰਾਜ ਮੈਂਬਰ ਹੋ?",
    pr_status_pending: "ਤਸਦੀਕ ਬਾਕੀ",
    pr_status_verified: "ਤਸਦੀਕਸ਼ੁਦਾ ਮੈਂਬਰ",
    pr_status_rejected: "ਅਸਵੀਕ੍ਰਿਤ",
    pr_designation_label2: "ਪਦ",
    pr_designation_sarpanch: "ਸਰਪੰਚ",
    pr_designation_panch: "ਪੰਚ",
    pr_designation_block_samiti_member: "ਬਲਾਕ ਸਮਿਤੀ ਮੈਂਬਰ",
    pr_designation_zila_parishad_member: "ਜ਼ਿਲ੍ਹਾ ਪਰਿਸ਼ਦ ਮੈਂਬਰ",
    pr_designation_chairman: "ਚੇਅਰਮੈਨ",
    pr_designation_vice_chairman: "ਵਾਈਸ ਚੇਅਰਮੈਨ",
    pr_designation_secretary: "ਸਕੱਤਰ",
    pr_designation_bdpo: "BDPO",
    pr_institution_type_label: "ਸੰਸਥਾ ਕਿਸਮ",
    select_institution_type: "ਸੰਸਥਾ ਕਿਸਮ ਚੁਣੋ",
    institution_type_gp: "ਗ੍ਰਾਮ ਪੰਚਾਇਤ",
    institution_type_bs: "ਬਲਾਕ ਸਮਿਤੀ",
    institution_type_zp: "ਜ਼ਿਲ੍ਹਾ ਪਰਿਸ਼ਦ",
    pr_institution_name_label: "ਸੰਸਥਾ ਨਾਮ",
    my_services: "ਮੇਰੀਆਂ ਸੇਵਾਵਾਂ",
    add_service: "ਸੇਵਾ ਸ਼ਾਮਲ ਕਰੋ",
    my_documents: "ਮੇਰੇ ਦਸਤਾਵੇਜ਼",
    add_document: "ਦਸਤਾਵੇਜ਼ ਸ਼ਾਮਲ ਕਰੋ",
    edit_profile: "ਪ੍ਰੋਫਾਈਲ ਸੰਪਾਦਿਤ ਕਰੋ",
    direct_login: "ਲੌਗਇਨ",
    // Quick Panels
    view_all_services: "ਸਾਰੀਆਂ ਸੇਵਾਵਾਂ ਦੇਖੋ",
    upload_new_document: "ਨਵਾਂ ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਕਰੋ",
    sync_whatsapp: "ਵਟਸਐਪ ਸਿੰਕ ਕਰੋ",
    clear_all: "ਸਭ ਹਟਾਓ",
    no_services_found: "ਕੋਈ ਸੇਵਾ ਨਹੀਂ ਮਿਲੀ।",
    no_documents_uploaded: "ਕੋਈ ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਨਹੀਂ ਕੀਤਾ ਗਿਆ।",
    no_new_notifications: "ਕੋਈ ਨਵੀਂ ਸੂਚਨਾ ਨਹੀਂ।",
    sign_in_google: "Google ਨਾਲ ਸਾਈਨ ਇਨ ਕਰੋ",
    sign_in_otp: "ਮੋਬਾਈਲ OTP ਨਾਲ ਸਾਈਨ ਇਨ ਕਰੋ",
    change_address: "ਬਦਲੋ",
    or_label: "ਜਾਂ",
    profile_prompt: "ਪੂਰੀਆਂ ਡੈਸ਼ਬੋਰਡ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਪੂਰੀ ਕਰੋ",
    namaste: "ਸਤਿ ਸ਼੍ਰੀ ਅਕਾਲ",
    my_notifications: "ਮੇਰੀਆਂ ਸੂਚਨਾਵਾਂ",
    // Farmer Services
    farmer_services_title: "ਕਿਸਾਨ ਅਤੇ ਪੇਂਡੂ ਸੇਵਾਵਾਂ",
    farmer_services_subtitle: "ਸਕੀਮਾਂ, ਸਬਸਿਡੀਆਂ, ਜ਼ਮੀਨੀ ਰਿਕਾਰਡ ਅਤੇ ਕਿਸਾਨ ਸਲਾਹ ਸੇਵਾਵਾਂ ਤੱਕ ਇੱਕੋ ਥਾਂ ਪਹੁੰਚੋ",
    service_farmer_id: "ਕਿਸਾਨ ਆਈਡੀ (AgriStack)",
    service_mfmb: "ਮੇਰੀ ਫਸਲ ਮੇਰਾ ਬਿਓਰਾ",
    service_land_records: "ਜਮ੍ਹਾਂਬੰਦੀ / ਜ਼ਮੀਨੀ ਰਿਕਾਰਡ",
    service_pm_kisan: "ਪੀਐਮ-ਕਿਸਾਨ ਸਨਮਾਨ ਨਿਧੀ",
    service_crop_advisory: "ਫਸਲ ਰੋਗ ਅਤੇ ਮੌਸਮ ਸਲਾਹ",
    service_pmfby: "ਫਸਲ ਬੀਮਾ (PMFBY)",
    service_agri_subsidies: "ਖੇਤੀਬਾੜੀ ਸਬਸਿਡੀ (ਸਰਗਰਮ ਸਕੀਮਾਂ)",
    service_pm_mandhan: "ਪੀਐਮ-ਕਿਸਾਨ ਮਾਨਧਨ (ਪੈਨਸ਼ਨ)",
    service_soil_health: "ਮਿੱਟੀ ਸਿਹਤ ਕਾਰਡ",
    service_kisan_call: "ਕਿਸਾਨ ਕਾਲ ਸੈਂਟਰ / ਸਲਾਹ",
    service_agri_infra_fund: "ਖੇਤੀਬਾੜੀ ਬੁਨਿਆਦੀ ਢਾਂਚਾ ਫੰਡ",

    // Academic Services
    academic_services_title: "ਸਿੱਖਿਆ ਅਤੇ ਕਰੀਅਰ",
    academic_services_desc: "ਦਾਖਲੇ, ਨਤੀਜੇ ਅਤੇ ਨੌਕਰੀ ਦੇ ਮੌਕੇ ਆਸਾਨੀ ਨਾਲ ਲੱਭੋ।",
    academic_admissions: "ਦਾਖਲੇ (Admissions)",
    academic_results: "ਪ੍ਰੀਖਿਆ ਨਤੀਜੇ",
    academic_jobs: "ਨੌਕਰੀ ਦੀਆਂ ਅਸਾਮੀਆਂ",
    // Certificate Services
    certificate_services_title: "ਨਾਗਰਿਕ ਸਰਟੀਫਿਕੇਟ",
    certificate_services_desc: "ਮਹੱਤਵਪੂਰਨ ਸਰਟੀਫਿਕੇਟਾਂ ਅਤੇ ਨਾਗਰਿਕ ਸੇਵਾਵਾਂ ਲਈ ਬਿਨਾਂ ਕਿਸੇ ਉਲਝਣ ਦੇ ਅਪਲਾਈ ਕਰੋ।",
    cert_birth_death: "ਜਨਮ ਅਤੇ ਮੌਤ ਸਰਟੀਫਿਕੇਟ",
    cert_caste: "ਜਾਤੀ ਸਰਟੀਫਿਕੇਟ",
    cert_residence: "ਰਿਹਾਇਸ਼ੀ ਸਰਟੀਫਿਕੇਟ",
    cert_income: "ਆਮਦਨ ਸਰਟੀਫਿਕੇਟ",
    cert_family_id: "ਪਰਿਵਾਰ ਪਛਾਣ ਪੱਤਰ (PPP)",
    cert_birth: "ਜਨਮ ਸਰਟੀਫਿਕੇਟ",
    cert_pension: "ਪੈਨਸ਼ਨ ਸੇਵਾਵਾਂ",
    cert_aadhaar: "ਆਧਾਰ ਸੇਵਾਵਾਂ",
    cert_driving_license: "ਡਰਾਈਵਿੰਗ ਲਾਇਸੰਸ",
    cert_ration_card: "ਰਾਸ਼ਨ ਕਾਰਡ",
    cert_voter_id: "ਵੋਟਰ ਆਈਡੀ",
    cert_character: "ਚਾਲ ਚਲਣ ਸਰਟੀਫਿਕੇਟ",
    cert_unemployment: "ਬੇਰੁਜ਼ਗਾਰੀ ਭੱਤਾ",
    // Grievance Services
    grievance_services_title: "ਲੋਕ ਸ਼ਿਕਾਇਤਾਂ",
    grievance_desc: "ਸ਼ਿਕਾਇਤਾਂ ਦਰਜ ਕਰੋ, ਬੇਨਤੀਆਂ ਨੂੰ ਟਰੈਕ ਕਰੋ ਅਤੇ ਸਹਾਇਤਾ ਪ੍ਰਾਪਤ ਕਰੋ",
    grievance_new: "ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰੋ",
    grievance_track: "ਸਥਿਤੀ ਟ੍ਰੈਕ ਕਰੋ",
    grievance_helpline: "ਹੈਲਪਲਾਈਨ ਨੰਬਰ",
    // Travel Services
    travel_services_title: "ਯਾਤਰਾ ਸੇਵਾਵਾਂ",
    travel_desc: "ਯਾਤਰਾ ਬੁੱਕ ਕਰੋ, ਰੂਟ ਚੈੱਕ ਕਰੋ ਅਤੇ ਟ੍ਰਾਂਸਪੋਰਟ ਨਾਲ ਸਬੰਧਤ ਸੇਵਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਕਰੋ।",
    travel_bus: "ਬੱਸ ਸੇਵਾਵਾਂ",
    travel_train: "ਰੇਲ ਸੇਵਾਵਾਂ",
    travel_routes: "ਰੂਟ ਮੈਪ",
    // Navigation
    back_to_menu: "ਮੀਨੂ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    back_home: "ਘਰ ਵਾਪਸ ਜਾਓ",
    home_tooltip: "ਘਰ",
    // Online Services Info
    why_use_title: "ਇਸ ਪੋਰਟਲ ਦੀ ਵਰਤੋਂ ਕਿਉਂ ਕਰੀਏ",
    why_use_intro: "**ਇੱਕ ਸਿੰਗਲ ਪ੍ਰੋਫਾਈਲ** ਬਣਾ ਕੇ, ਤੁਹਾਨੂੰ ਮਿਲਦਾ ਹੈ:",
    why_use_point_1: "**ਏਕੀਕ੍ਰਿਤ ਪਹੁੰਚ**: ਸਕੀਮਾਂ, ਸਰਟੀਫਿਕੇਟਾਂ ਅਤੇ ਨੌਕਰੀਆਂ ਲਈ ਇੱਕ ਥਾਂ ਤੋਂ ਅਪਲਾਈ ਕਰੋ।",
    why_use_point_2: "**ਸੁਰੱਖਿਅਤ ਸਟੋਰੇਜ**: ਆਪਣੇ ਸਾਰੇ ਦਸਤਾਵੇਜ਼ਾਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਅਤੇ ਪਹੁੰਚਯੋਗ ਰੱਖੋ।",
    why_use_point_3: "**ਸਮੇਂ ਸਿਰ ਸੂਚਨਾਵਾਂ**: ਅਰਜ਼ੀ ਦੀ ਸਥਿਤੀ ਅਤੇ ਨਵੀਆਂ ਸਕੀਮਾਂ ਬਾਰੇ ਅਪਡੇਟ ਪ੍ਰਾਪਤ ਕਰੋ।",
    why_use_footer: "ਸਮਾਂ ਬਚਾਓ ਅਤੇ ਕਈ ਦਫਤਰਾਂ ਦੇ ਚੱਕਰ ਲਗਾਉਣ ਤੋਂ ਬਚੋ।",
    disclaimer_portal_title: "ਬੇਦਾਅਵਾ",
    disclaimer_portal_body: "ਇਹ ਪੋਰਟਲ ਸਿਰਫ ਜਾਣਕਾਰੀ ਅਤੇ ਸਹੂਲਤ ਲਈ ਪ੍ਰਦਾਨ ਕੀਤਾ ਗਿਆ ਹੈ। ਅਧਿਕਾਰਤ ਕਾਰਵਾਈ ਸਬੰਧਤ ਵਿਭਾਗਾਂ ਦੁਆਰਾ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
    how_to_use_portal_title: "ਇਸ ਪੋਰਟਲ ਦੀ ਵਰਤੋਂ ਕਿਵੇਂ ਕਰੀਏ",
    how_to_use_step_1: "ਉੱਪਰ **ਸ਼੍ਰੇਣੀ ਟੈਬ** 'ਤੇ ਕਲਿੱਕ ਕਰੋ (ਜਿਵੇਂ, ਕਿਸਾਨ, ਵਿਦਿਆਰਥੀ)।",
    how_to_use_step_2: "**ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਬਣਾਓ** ਜਾਂ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਲੌਗ ਇਨ ਕਰੋ।",
    how_to_use_step_3: "ਉਪਲਬਧ ਸੇਵਾਵਾਂ ਨੂੰ ਬ੍ਰਾਊਜ਼ ਕਰੋ ਅਤੇ **ਆਨਲਾਈਨ ਅਪਲਾਈ ਕਰੋ**।",
    how_to_use_step_4: "ਜ਼ਰੂਰੀ ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਕਰੋ ਅਤੇ ਜਮ੍ਹਾਂ ਕਰੋ।",
    how_to_use_step_5: "ਸਥਿਤੀ ਟ੍ਰੈਕ ਕਰੋ ਅਤੇ ਡਿਜੀਟਲ ਰੂਪ ਵਿੱਚ ਸਰਟੀਫਿਕੇਟ ਪ੍ਰਾਪਤ ਕਰੋ।",
    how_to_use_footer: "ਮਦਦ ਚਾਹੀਦੀ ਹੈ? ਸ਼ਿਕਾਇਤ ਟੈਬ 'ਤੇ ਜਾਓ।",
    disclaimer_label: "ਬੇਦਾਅਵਾ",
    disclaimer_text: "ਪੀਆਰਆਈ ਮੈਂਬਰਾਂ ਦੀਆਂ ਤਸਵੀਰਾਂ ਸਿਰਫ ਜਨਤਕ ਜਾਣਕਾਰੀ ਦੇ ਉਦੇਸ਼ਾਂ ਲਈ ਸਹਿਮਤੀ ਨਾਲ ਪ੍ਰਕਾਸ਼ਤ ਕੀਤੀਆਂ ਗਈਆਂ ਹਨ। ਇਹ ਪਲੇਟਫਾਰਮ ਕੋਈ ਅਧਿਕਾਰਤ ਸਰਕਾਰੀ ਰਿਕਾਰਡ ਨਹੀਂ ਹੈ। ਕੋਈ ਵੀ ਮੈਂਬਰ ਕਿਸੇ ਵੀ ਸਮੇਂ ਆਪਣੀ ਜਾਣਕਾਰੀ ਵਿੱਚ ਸੁਧਾਰ ਜਾਂ ਹਟਾਉਣ ਦੀ ਬੇਨਤੀ ਕਰ ਸਕਦਾ ਹੈ।",
  },
}

export const t = (key: string, lang: Language) => {
  const text = uiText[lang]?.[key]
  if (text) return text

  const fallback = uiText.en[key]
  if (fallback) {
    if (lang !== 'en' && import.meta.env.DEV) {
      console.warn(`[i18n] Missing translation for '${key}' in '${lang}'`)
    }
    return fallback
  }

  return key
}

// Simple template formatter with {var} placeholders
export const formatTemplate = (template: string, vars: Record<string, string>): string => {
  return template.replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : `{${k}}`))
}

// Translate and format in one step; preserves English fallback
export const tf = (
  key: string,
  lang: Language,
  vars?: Record<string, string>
): string => {
  const base = t(key, lang)
  return vars ? formatTemplate(base, vars) : base
}

import { excelHiMap, excelPaMap, EXCEL_SOURCE_BRAND } from "./allpanlanc.maps"

const normalize = (s: string) => s.replace(/\s+/g, " ").trim()
const fold = (s: string) => normalize(s).toLowerCase()

let sourceValidated = false
// IMPORTANT: Names for districts/blocks/GPs/wards/sarpanches MUST come only
// from allpanlanc.xlsx-derived maps. The previous self-translated logic
// (local name maps, token heuristics, transliteration) was removed to prevent
// data mixing and ensure a single source of truth. Do not reintroduce any
// non-Excel name logic in this module.
const ensureExcelSource = () => {
  if (sourceValidated) return
  if (!EXCEL_SOURCE_BRAND || EXCEL_SOURCE_BRAND !== "allpanlanc.xlsx") {
    throw new Error("Excel source validation failed: non-Excel mapping detected")
  }
  sourceValidated = true
}

let hiFoldMap: Record<string, string> | null = null
let paFoldMap: Record<string, string> | null = null

const ensureFoldMaps = () => {
  if (!hiFoldMap) {
    const out: Record<string, string> = {}
    for (const [k, v] of Object.entries(excelHiMap as Record<string, string>)) {
      const key = fold(k)
      if (key) out[key] = v
    }
    hiFoldMap = out
  }
  if (!paFoldMap) {
    const out: Record<string, string> = {}
    for (const [k, v] of Object.entries(excelPaMap as Record<string, string>)) {
      const key = fold(k)
      if (key) out[key] = v
    }
    paFoldMap = out
  }
}

export const translateName = (name: string, lang: Language) => {
  ensureExcelSource()
  const n = normalize(name)
  const key = fold(name)
  if (lang === "hi" || lang === "pa") ensureFoldMaps()
  if (lang === "hi") {
    const direct = (hiFoldMap && hiFoldMap[key]) || excelHiMap[n] || excelHiMap[n.toUpperCase()]
    return direct ?? name
  }
  if (lang === "pa") {
    const direct = (paFoldMap && paFoldMap[key]) || excelPaMap[n] || excelPaMap[n.toUpperCase()]
    return direct ?? name
  }
  return name
}

// Text direction helper: extendable for RTL languages if added later
export const isRTL = (lang: Language): boolean => {
  // All current languages (en, hi, pa) are LTR; placeholder for future RTL additions
  return ["ar", "fa", "ur"].includes(lang as unknown as string)
}

// Public direction helper supporting non-registered language codes as well
export const direction = (langCode: Language | string): "ltr" | "rtl" =>
  ["ar", "fa", "ur", "he"].includes(langCode as string) ? "rtl" : "ltr"
